<template>
  <div id="caseinput">
    <loading-overlay v-if="loading"></loading-overlay>
    <div class="title">
      <h2>{{ titleType }}</h2>
    </div>
    <div class="main">
      <div class="case">
        <div class="top">
          <div class="icon"></div>
          <div>案件信息</div>
        </div>
        <div class="contain">
          <el-form
            class="form"
            ref="formref"
            :model="form"
            :rules="rules"
            label-width="180px"
          >
            <div
              v-if="
                numType == 1 ||
                numType == 2 ||
                numType == 3 ||
                numType == 4 ||
                numType == 5 ||
                numType == 6
              "
            >
              <el-row>
                <el-col :span="24" v-if="numType == 3">
                  <el-form-item label="公益诉讼" prop="public_welfare">
                    <el-select
                      v-model="form.bcz.public_welfare"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="案件名称" prop="name">
                    <el-input
                      v-model="form.name"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="受理机构案号" prop="acceptcode">
                    <el-input
                      v-model="form.acceptcode"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="案件编号" prop="code">
                    <el-input
                      v-model="form.code"
                      placeholder="自动编号"
                      disabled
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="numType != 4">
                  <el-form-item label="法律援助" prop="assist">
                    <el-select
                      v-model="form.assist"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in Flyz"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="案卷状态" prop="ajstatus">
                    <el-select
                      v-model="form.ajstatus"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                      @change="inputType(form.ajstatus, null)"
                    >
                      <el-option
                        v-for="item in Ajstatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col v-if="false" :span="6">
                  <el-form-item label="受理状态" prop="casestatus">
                    <el-select
                      v-model="form.casestatus"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in CaseStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" class="date_box">
                  <el-form-item label="收案日期" prop="approvaldate">
                    <div
                      class="date_box"
                      @mouseover="onMouseOver()"
                      @mouseleave="onMouseleave()"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="form.approvaldate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                      <i class="el-icon-date" ref="iconDate"></i>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="案由" prop="cause">
                    <el-input
                      v-model="form.cause"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="案件来源" prop="source">
                    <el-input
                      v-model="form.source"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理机构" prop="acceptUnit">
                    <el-input
                      v-model="form.acceptUnit"
                      placeholder="请输入"
                      clearable
                      prop="acceptUnit"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="代理律师" prop="leadLawyer">
                    <el-select
                      style="width: 100%"
                      v-model="form.leadLawyer"
                      placeholder="请选择"
                      class="select"
                      clearable
                      multiple
                      filterable
                      :multiple-limit="1"
                      @change="LeadLawyerChange(form.leadLawyer, null)"
                    >
                      <el-option
                        v-for="item in Lawyer"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="代理律师" prop="coCounsel">
                    <el-select
                      style="width: 100%"
                      v-model="form.coCounsel"
                      placeholder="请选择"
                      class="select"
                      clearable
                      multiple
                      filterable
                    >
                      <el-option
                        v-for="item in Lawyer"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item
                    label="部门主管"
                    prop="caseLeaders"
                    key="caseLeaders"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.caseLeaders"
                      placeholder="请选择"
                      class="select"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in CaseLeaders"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="6"
                  v-if="
                    numType != 7 &&
                    numType != 8 &&
                    numType != 14 &&
                    numType != 9
                  "
                >
                  <el-form-item label="二次审批人" prop="level">
                    <el-select
                      style="width: 100%"
                      v-model="form.level"
                      placeholder="请选择"
                      class="select"
                      clearable
                      multiple
                      :multiple-limit="1"
                      filterable
                    >
                      <el-option
                        v-for="item in Level"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="false">
                  <el-form-item label="委托事项" prop="remark">
                    <el-select
                      style="width: 100%"
                      v-model="form.remark"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in Entrust"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item
                  v-if="numType == 2"
                  label="介入阶段"
                  prop="intervene"
                >
                  <el-select
                    style="width: 100%"
                    v-model="form.bcz.intervene"
                    placeholder="请选择"
                    class="select"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in Intervene"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col v-if="numType == 2" :span="24">
                  <el-form-item label="刑事风险控制人" prop="criminalrisk">
                    <el-select
                      style="width: 100%"
                      v-model="form.criminalrisk"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in Criminal"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div v-else>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="
                  numType != 7 && numType != 8 && numType != 14 && numType != 9
                "
              >
                <el-form-item label="受理机构案号" prop="acceptcode">
                  <el-input
                    v-model="form.acceptcode"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="项目概要" prop="cause">
                  <el-input
                    v-model="form.cause"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="案件编号" prop="code">
                    <el-input
                      v-model="form.code"
                      placeholder="自动编号"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="案卷状态" prop="ajstatus">
                    <el-select
                      v-model="form.ajstatus"
                      placeholder="请选择"
                      class="input"
                      style="width: 100%"
                      filterable
                      @change="inputType(form.ajstatus, null)"
                    >
                      <el-option
                        v-for="item in Ajstatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="项目合伙人" prop="partner">
                    <el-input
                      v-model="form.bcz.partner"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="底稿资料" prop="draft">
                    <el-select
                      v-model="form.bcz.draft"
                      placeholder="请选择"
                      class="select"
                      filterable
                    >
                      <el-option
                        v-for="item in Draft"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col v-if="false" :span="8">
                  <el-form-item label="受理状态" prop="casestatus">
                    <el-select
                      v-model="form.casestatus"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in CaseStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- <div class="divider"></div> -->

              <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
              <div v-if="numType == 10">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="开放时间" prop="opentime">
                      <el-date-picker
                        style="width: 100%"
                        v-model="form.bcz.opentime"
                        placeholder="请选择时间"
                        value-format="yyyy-MM-dd"
                        type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="采购方式" prop="procuremethod">
                      <el-input
                        v-model="form.bcz.procuremethod"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="预算金额" prop="budgetmoney">
                      <el-input
                        v-model="form.bcz.budgetmoney"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="采购编号" prop="procurecode">
                      <el-input
                        v-model="form.bcz.procurecode"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <el-row>
                <el-col :span="6" class="date_box">
                  <el-form-item label="立项日期" prop="approvaldate">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.approvaldate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="请选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="项目来源" prop="source">
                    <el-input
                      v-model="form.source"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    v-if="numType == 10"
                    :label="numType == 10 ? '代理机构' : '受理机构'"
                    prop="acceptUnit"
                  >
                    <el-input v-model="form.acceptUnit"></el-input>
                  </el-form-item>
                  <el-form-item v-if="numType != 10" label="受理机构">
                    <el-input v-model="form.acceptUnit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="6"
                  v-if="
                    numType == 7 ||
                    numType == 8 ||
                    numType == 14 ||
                    numType == 9 ||
                    numType == 11 ||
                    numType == 15
                  "
                >
                  <el-form-item label="项目分类" prop="classification">
                    <el-input v-model="form.bcz.classification"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="numType == 10">
                  <el-form-item label="项目类型" prop="projecttype">
                    <el-select
                      style="width: 100%"
                      v-model="form.bcz.projecttype"
                      filterable
                    >
                      <el-option
                        v-for="item in Projecttype"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label="numType == 10 ? '服务律师' : '代理律师'"
                    prop="leadLawyer"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.leadLawyer"
                      class="select"
                      multiple
                      filterable
                      :multiple-limit="1"
                      @change="LeadLawyerChange(form.leadLawyer, null)"
                    >
                      <el-option
                        v-for="item in Lawyer"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="代理律师" prop="coCounsel">
                    <el-select
                      style="width: 100%"
                      v-model="form.coCounsel"
                      placeholder="请选择"
                      class="select"
                      clearable
                      multiple
                      filterable
                    >
                      <el-option
                        v-for="item in Lawyer"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="部门主管"
                    prop="caseLeaders"
                    key="caseLeaders"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.caseLeaders"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in CaseLeaders"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  v-if="numType == 7 || numType == 8 || numType == 14"
                >
                  <el-form-item label="风控委" prop="level">
                    <el-select
                      style="width: 100%"
                      v-model="form.level"
                      class="select"
                      multiple
                      filterable
                      :multiple-limit="2"
                    >
                      <el-option
                        v-for="item in FKW"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12" v-if="numType == 9">
                  <el-form-item label="风控委" prop="level">
                    <el-select
                      style="width: 100%"
                      v-model="form.level"
                      class="select"
                      multiple
                      filterable
                      :multiple-limit="1"
                    >
                      <el-option
                        v-for="item in FKW"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
              <el-row
                v-if="
                  numType != 7 &&
                  (numType != 8) & (numType != 14) &&
                  numType != 9
                "
              >
                <el-col :span="24">
                  <el-form-item label="二次审批人" prop="level">
                    <el-select
                      style="width: 100%"
                      v-model="form.level"
                      placeholder="请选择"
                      class="select"
                      clearable
                      multiple
                      filterable
                      :multiple-limit="1"
                    >
                      <el-option
                        v-for="item in Level"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 专项服务合同独有字段 -->
              <div v-if="numType == 11 || numType == 15">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="合同服务类型" prop="contracttype">
                      <el-input
                        v-model="form.bcz.contracttype"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="服务期限" prop="servicetime">
                      <el-date-picker
                        style="width: 100%"
                        v-model="form.bcz.servicetime"
                        value-format="yyyy-MM-dd"
                        type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <el-row v-if="numType != 9&&numType!=11">
                <el-col :span="24">
                  <el-form-item v-if="numType==10"
                    label="采购单位"
                    prop="bcz.procureunit"
                    :rules="[
                      { required: true, message: '不能为空', trigger: 'blur' }
                    ]"
                  >
                    <el-input
                      v-model="form.bcz.procureunit"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14" v-if="numType!=10">
                  <el-form-item v-if="numType!=11"
                  label="客户名称"
                    prop="bcz.procureunit"
                    :rules="[
                      { required: true, message: '不能为空', trigger: 'blur' }
                    ]"
                  >
                    <el-input
                      v-model="form.bcz.procureunit"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="numType==11"
                    label="客户名称"
                    prop="bcz.procureunit"
                    :rules="[
                      { required: true, message: '不能为空', trigger: 'blur' }
                    ]"
                  >  <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma2(form.bcz)"
                          v-model="form.bcz.procureunit"
                          :fetch-suggestions="querySearchName2
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="handleSelectName2
                          "
                        ></el-autocomplete>
                    <!-- <el-input
                      v-model="form.bcz.procureunit"
                      placeholder="请输入"
                      @input="filterComma2(form.bcz)"
                    ></el-input> -->
                  </el-form-item>

                </el-col>
                
                <el-col :span="10" v-if="numType != 10">
                
                  <el-form-item
                    label="身份证号/社会信用代码/护照号" label-width="260px"
                    prop="bcz.idnumber"
                    :rules="[
                        { required: true, message: '不能为空', trigger: 'blur' }
                      ]"
                  >
                  <!-- <el-autocomplete
                          class="input_autocomplete"
                          v-model="form.bcz.idnumber"
                          @input="filterComma2(form.bcz)"
                          :fetch-suggestions="querySearchId2
                          "
                          placeholder="请输入内容"
                          @select="handleSelectId2"
                        ></el-autocomplete> -->
                    <el-input
                      v-model="form.bcz.idnumber"
                      placeholder="请输入"
                      
                      @input="filterComma2(form.bcz)"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="numType==11" v-for="(item ,index) in form.bcz.tableData">
                  <el-col :span="12" >
                  <el-form-item 
                    label="客户名称"
                    :prop="`bcz.tableData[${index}].name`"
                    :rules="[
                      { required: true, message: '不能为空', trigger: 'blur' }
                    ]"
                  >  <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma3(form.bcz.tableData[index])"
                          v-model="form.bcz.tableData[index].name"
                          :fetch-suggestions="querySearchName3
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                         @select="(selected) => handleSelectName3(selected, index)"></el-autocomplete>
                  </el-form-item>

                </el-col>
                
                <el-col :span="10">
                
                  <el-form-item
                    label="身份证号/社会信用代码/护照号" label-width="260px"
                   :prop="`bcz.tableData[${index}].idnumber`"
                    :rules="[
                        { required: true, message: '不能为空', trigger: 'blur' }
                      ]"
                  >
                    <el-input
                     v-model="form.bcz.tableData[index].idnumber"
                      placeholder="请输入"
                      
                      @input="filterComma3(form.bcz.tableData[index])"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="text-align:right">
                  <el-button type="primary" @click="addParty3()" size="mini">
                        <div class="copy">+</div>
                      </el-button>
                      <el-button size="mini"
                        type="danger" 
                        @click="reduceParty3(index)"
                      >
                        <div class="del_btn">-</div>
                      </el-button>
                </el-col>
              </el-row>
            </div>
            <div></div>
            <!-- 案件当事人 -->
            <div
              v-if="
                numType == 1 ||
                numType == 2 ||
                numType == 3 ||
                numType == 4 ||
                numType == 5 ||
                numType == 6
              "
            >
              <div class="divider"></div>
              <div class="top">
                <div class="icon"></div>
                <div>案件当事人</div>
                <div class="addrow">
                  <el-select v-model="addTableData" clearable filterable>
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-button size="mini" type="primary" @click="addParty(null)">
                    添加当事人
                  </el-button>
                </div>
              </div>
              <!-- <el-row class="addrow"> </el-row> -->
              <el-row>
                <el-table
                  class="party"
                  :data="form.tableData"
                  style="width: calc(100% - 61px);"
                  :header-cell-style="{ textAlign: 'center' }"
                  :cell-style="{ textAlign: 'center' }"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column
                    label="属性"
                    prop="Attribute"
                    :render-header="addRedStar"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.Attribute" label-width="0">
                        <el-select
                          size="mini"
                          v-model="scope.row.Attribute"
                          filterable
                          @change="dsrOrder(scope.row)"
                        >
                          <el-option
                            v-for="item in ArrtibuteOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="类型"
                    prop="IsUnit"
                    :render-header="addRedStar"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.IsUnit" label-width="0">
                        <el-select
                          size="mini"
                          v-model="scope.row.IsUnit"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="姓名/单位名称"
                    prop="Name"
                    :render-header="addRedStar"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.Name" label-width="0">
                        <el-autocomplete v-if="scope.row.IsUnit==false"
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Name"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchName(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="
                            (item) => {
                              handleSelectName(item, scope.row)
                            }
                          "
                        ></el-autocomplete>
                        <el-input v-else
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Name"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                        <!-- <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Name"
                          clearable
                          
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearch(item1, item2, scope.row)
                            }
                          "
                          @select="
                            (item) => {
                              handleSelect(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="身份证号/社会信用代码/护照号"
                    prop="Idnumber"
                    :render-header="addRedStar"
                  >
                    <template slot-scope="scope">
                      <el-form-item  label-width="0" :rules="rules.Idnumber">
                        <!-- <el-autocomplete
                          class="input_autocomplete"
                          v-model="scope.row.Idnumber"
                          @input="filterComma(scope.row)"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchId(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          @select="
                            (item) => {
                              handleSelectId(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                        <el-input
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Idnumber"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
               
                  <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="addParty(scope.row)">
                        <div class="copy">+</div>
                      </el-button>
                      <el-button
                        type="danger"
                        @click="reduceParty(scope.row.count)"
                      >
                        <div class="del_btn">-</div>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否代理"
                    prop="IsClient"
                    :render-header="addRedStar"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.IsClient" label-width="0">
                        <!-- <el-select
                          size="mini"
                          v-model="scope.row.IsClient"
                          clearable
                          filterable
                          @change="clientChange(scope.row)"
                        >
                          <el-option
                            v-for="item in isClient"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select> -->

                        <el-checkbox
                          v-model="scope.row.IsClient"
                          @change="clientChange(scope.row)"
                        ></el-checkbox>
                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </div>

            <div v-if="numType == 9">
              <div class="divider"></div>
              <div class="top">
                <div class="icon"></div>
                <div>案件当事人</div>
                <div class="addrow">
                  <el-select v-model="addTableData" clearable filterable>
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="addParty09(null)"
                  >
                    添加当事人
                  </el-button>
                </div>
              </div>
              <!-- <el-row class="addrow">
                <el-select v-model="addTableData" clearable filterable>
                  <el-option
                    v-for="item in ArrtibuteOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button size="mini" type="primary" @click="addParty09(null)">
                  添加当事人
                </el-button>
              </el-row> -->
              <el-row>
                <el-table
                  class="party"
                  :data="form.tableData"
                  style="width: calc(100% - 61px);"
                  :header-cell-style="{ textAlign: 'center' }"
                  :cell-style="{ textAlign: 'center' }"
                  :row-class-name="tableRowClassName"
                >
                  <!-- <el-table-column label="是否必填">
                    <template slot-scope="scope">
                      {{ sfbt(scope.row.Attribute) }}
                    </template>
                  </el-table-column> -->

                  <el-table-column
                    label="属性"
                    prop="Attribute"
                    :render-header="addRedStar"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.Attribute" label-width="0">
                        <el-select
                          size="mini"
                          v-model="scope.row.Attribute"
                          filterable
                          @change="dsrOrder(scope.row)"
                          disabled
                        >
                          <el-option
                            v-for="item in ArrtibuteOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  
                  <el-table-column
                    label="姓名/单位名称"
                    prop="Name"
                    :render-header="addRedStar"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.Name" label-width="0">
                        <el-autocomplete v-if="scope.row.IsUnit==false"
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Name"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchName(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="
                            (item) => {
                              handleSelectName(item, scope.row)
                            }
                          "
                        ></el-autocomplete>
                        <el-input v-else
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Name"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                        <!-- <el-autocomplete
                          @input="filterComma(scope.row)"
                          class="input_autocomplete"
                          v-model="scope.row.Name"
                          clearable
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearch(item1, item2, scope.row)
                            }
                          "
                          @select="
                            (item) => {
                              handleSelect(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="身份证号/社会信用代码/护照号"
                    prop="Idnumber"
                    :render-header="addRedStar"
                  >
                    <template slot-scope="scope">
                      <el-form-item  label-width="0" :rules="rules.Idnumber">
                        <!-- <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Idnumber"
                          :fetch-suggestions="
                            (item1, item2) => {
                              querySearchId(item1, item2, scope.row)
                            }
                          "
                          placeholder="请输入内容"
                          @select="
                            (item) => {
                              handleSelectId(item, scope.row)
                            }
                          "
                        ></el-autocomplete> -->
                        <el-input
                          class="input_autocomplete"
                          @input="filterComma(scope.row)"
                          v-model="scope.row.Idnumber"
                          clearable
                          placeholder="请输入内容"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="addParty09(scope.row)">
                        <div class="copy">+</div>
                      </el-button>
                      <el-button
                        type="danger"
                        @click="reduceParty(scope.row.count)"
                      >
                        <div class="del_btn">-</div>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否代理"
                    prop="IsClient"
                    :render-header="addRedStar"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <el-form-item :rules="rules.IsClient" label-width="0">
                        <!-- <el-select
                          size="mini"
                          v-model="scope.row.IsClient"
                          clearable
                          filterable
                          @change="clientChange(scope.row)"
                        >
                          <el-option
                            v-for="item in isClient"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select> -->

                        <!-- <el-checkbox
                          disabled
                          v-model="scope.row.IsClient"
                          @change="clientChange(scope.row)"
                        ></el-checkbox> -->
                        <el-checkbox v-if="scope.row.Attribute=='客户名称'"
                          disabled
                          v-model="isTrue"
                          @change="clientChange(scope.row)"
                        ></el-checkbox>
                        <el-checkbox v-else
                          disabled
                          v-model="isFalse"
                          @change="clientChange(scope.row)"
                        ></el-checkbox>

                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </div>

            <!-- 收费信息 -->
            <div class="divider"></div>
            <div class="top">
              <div class="icon"></div>
              <div>收费信息</div>
            </div>

            <el-row>
              <el-col :span="6">
                <el-form-item label="收费方式" prop="chargingMethod">
                  <el-select
                    style="width: 100%"
                    v-model="form.chargingMethod"
                    placeholder="请选择"
                    filterable
                    class="select"
                    @change="SF_Chargestatus(form.chargingMethod)"
                  >
                    <el-option
                      v-for="item in Chargestatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="numType != 10">
                <el-form-item label="案件标的" prop="subjectMatter ">
                  <el-input
                    v-model="form.subjectMatter"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6" class="date_box" style="display: flex">
                <el-form-item
                  :label="numType == 10 ? '投标价格' : '标的金额'"
                  prop="amountOfSubject"
                >
                  <el-input
                    v-model="form.amountOfSubject"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
                <span style="margin: 1% 0 0 0.5%">元</span>
              </el-col>
              <el-col
                :span="6"
                class="date_box"
                style="display: flex"
                v-if="sfxz.fixed"
              >
                <el-form-item label="收费金额" prop="fixed">
                  <el-input
                    v-model="form.fixed"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
                <span style="margin: 1% 0 0 0.5%">元</span>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="12" v-if="sfxz.fixed_times"> </el-col> -->
              <el-col
                :span="12"
                class="date_box"
                style="display: flex"
                v-if="sfxz.riskFixed"
              >
                <el-form-item label="半风险定额收费金额" prop="riskFixed">
                  <el-input
                    v-model="form.riskFixed"
                    placeholder="请输入"
                    clearable
                  ></el-input> </el-form-item
                ><span style="margin: 1% 0 0 0.5%">元</span>
              </el-col>
              <el-col :span="12" style="display: flex" v-if="sfxz.riskRatio">
                <el-form-item label="风险收费比例" prop="riskRatio ">
                  <el-input
                    v-model="form.riskRatio"
                    placeholder="请输入"
                    clearable
                  ></el-input> </el-form-item
                ><span style="margin: 1% 0 0 0.5%">%</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="date_box">
                <el-form-item label="简介" prop="introduction">
                  <el-input
                    v-model="form.introduction"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="sf_remark ">
                  <el-input
                    v-model="form.sf_remark"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 附件信息 -->
            <div class="divider"></div>
            <div class="top">
              <div class="icon"></div>
              <div>附件信息</div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="普通附件"
                  prop="ordinaryFiles"
                  v-if="numType != 10"
                >
                  <el-upload
                    class="upload_file"
                    :show-file-list="false"
                    v-model="form.ordinaryFiles"
                    action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=附件"
                    :before-upload="(file) => beforeUpload(file, 2)"
                    :on-change="(file) => onChange(file, 2)"
                    :on-progress="(event, file) => onProgress(event, file, 2)"
                    multiple
                    :file-list="FileList2"
                    :on-success="
                      (response, file, fileList) =>
                        uploadSuccess(response, file, fileList, 2)
                    "
                    :on-remove="(file) => handleRemove(file, 2)"
                  >
                    <el-button size="small" class="fj_text"
                      >请选择附件</el-button
                    >
                    <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                  </el-upload>
                  <!-- 附件回显 -->
                  <div
                    v-for="(item, index) in FileList2"
                    :key="item.uid"
                    class="file_show"
                    style="margin-top: 10px"
                  >
                    <div class="fj" v-if="!item.isShow">
                      <div style="flex: 1">
                        <img
                          src="../../assets/file/word.svg"
                          v-if="
                            item.ftype == 'doc' ||
                            item.ftype == 'docx' ||
                            item.ftype == 'DOC' ||
                            item.ftype == 'DOCX'
                          "
                        />
                        <img
                          src="../../assets/file/xls.svg"
                          v-if="
                            item.ftype == 'xlsx' ||
                            item.ftype == 'xls' ||
                            item.ftype == 'XLSX' ||
                            item.ftype == 'XLS'
                          "
                        />
                        <img
                          src="../../assets/file/png.svg"
                          v-if="
                            item.ftype == 'jpg' ||
                            item.ftype == 'jpeg' ||
                            item.ftype == 'png' ||
                            item.ftype == 'JPG' ||
                            item.ftype == 'JPEG' ||
                            item.ftype == 'PNG'
                          "
                        />
                        <img
                          src="../../assets/file/PDF.svg"
                          v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                        />
                      </div>
                      <div class="name" style="flex: 9">
                        <div>
                          {{ item.name }}
                        </div>
                        <div class="word">
                          <span @click="look(item)" class="look">预览</span>
                          <span class="down" @click="down(item)">下载</span>
                          <span @click="del(index, 2)" class="del">删除</span>
                        </div>
                      </div>
                    </div>
                    <!--文件上传进度条-->
                    <div class="uploadprocess" v-else>
                      <div>
                        <div class="jdtext">
                          <div class="uploadname">{{ item.name }}</div>
                          <div class="per">{{ item.curPercentage }}%</div>
                        </div>
                        <el-progress
                          :percentage="item.curPercentage"
                          :show-text="false"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :span="12" style="display: flex">
                <el-form-item
                  :label="numType == 10 ? '招标文件' : '合同上传'"
                  prop="biddingSchemes"
                >
                  <el-upload
                    class="upload_file"
                    :show-file-list="false"
                    v-model="form.biddingSchemes"
                    action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=合同"
                    :before-upload="(file) => beforeUpload(file, 1)"
                    :on-change="(file) => onChange(file, 1)"
                    :on-progress="(event, file) => onProgress(event, file, 1)"
                    multiple
                    :file-list="FileList1"
                    :on-success="
                      (response, file, fileList) =>
                        uploadSuccess(response, file, fileList, 1)
                    "
                    :on-remove="(file) => handleRemove(file, 1)"
                  >
                    <el-button size="small" class="fj_text"
                      >请选择附件</el-button
                    >
                    <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                  </el-upload>
                  <!-- 附件回显 -->
                  <div
                    v-for="(item, index) in FileList1"
                    :key="item.uid"
                    class="file_show"
                    style="margin-top: 10px"
                  >
                    <div class="fj" v-if="!item.isShow">
                      <div style="flex: 1">
                        <img
                          src="../../assets/file/word.svg"
                          v-if="
                            item.ftype == 'doc' ||
                            item.ftype == 'docx' ||
                            item.ftype == 'DOC' ||
                            item.ftype == 'DOCX'
                          "
                        />
                        <img
                          src="../../assets/file/xls.svg"
                          v-if="
                            item.ftype == 'xlsx' ||
                            item.ftype == 'xls' ||
                            item.ftype == 'XLSX' ||
                            item.ftype == 'XLS'
                          "
                        />
                        <img
                          src="../../assets/file/png.svg"
                          v-if="
                            item.ftype == 'jpg' ||
                            item.ftype == 'jpeg' ||
                            item.ftype == 'png' ||
                            item.ftype == 'JPG' ||
                            item.ftype == 'JPEG' ||
                            item.ftype == 'PNG'
                          "
                        />
                        <img
                          src="../../assets/file/PDF.svg"
                          v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                        />
                      </div>
                      <div class="name" style="flex: 9">
                        <div>
                          {{ item.name }}
                        </div>
                        <div class="word">
                          <span @click="look(item)" class="look">预览</span>
                          <span class="down" @click="down(item)">下载</span>
                          <span @click="del(index, 1)" class="del">删除</span>
                        </div>
                      </div>
                    </div>
                    <!--文件上传进度条-->
                    <div class="uploadprocess" v-else>
                      <div>
                        <div class="jdtext">
                          <div class="uploadname">{{ item.name }}</div>
                          <div class="per">{{ item.curPercentage }}%</div>
                        </div>
                        <el-progress
                          :percentage="item.curPercentage"
                          :show-text="false"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" style="display: flex">
                <el-form-item
                  label="普通附件"
                  prop="ordinaryFiles"
                  v-if="numType == 10"
                >
                  <el-upload
                    class="upload_file"
                    :show-file-list="false"
                    v-model="form.ordinaryFiles"
                    action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=附件"
                    :before-upload="(file) => beforeUpload(file, 2)"
                    :on-change="(file) => onChange(file, 2)"
                    :on-progress="(event, file) => onProgress(event, file, 2)"
                    multiple
                    :file-list="FileList2"
                    :on-success="
                      (response, file, fileList) =>
                        uploadSuccess(response, file, fileList, 2)
                    "
                    :on-remove="(file) => handleRemove(file, 2)"
                  >
                    <el-button size="small" class="fj_text"
                      >请选择附件</el-button
                    >
                    <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                  </el-upload>
                  <!-- 附件回显 -->
                  <div
                    v-for="(item, index) in FileList2"
                    :key="item.uid"
                    class="file_show"
                    style="margin-top: 10px"
                  >
                    <div class="fj" v-if="!item.isShow">
                      <div style="flex: 1">
                        <img
                          src="../../assets/file/word.svg"
                          v-if="
                            item.ftype == 'doc' ||
                            item.ftype == 'docx' ||
                            item.ftype == 'DOC' ||
                            item.ftype == 'DOCX'
                          "
                        />
                        <img
                          src="../../assets/file/xls.svg"
                          v-if="
                            item.ftype == 'xlsx' ||
                            item.ftype == 'xls' ||
                            item.ftype == 'XLSX' ||
                            item.ftype == 'XLS'
                          "
                        />
                        <img
                          src="../../assets/file/png.svg"
                          v-if="
                            item.ftype == 'jpg' ||
                            item.ftype == 'jpeg' ||
                            item.ftype == 'png' ||
                            item.ftype == 'JPG' ||
                            item.ftype == 'JPEG' ||
                            item.ftype == 'PNG'
                          "
                        />
                        <img
                          src="../../assets/file/PDF.svg"
                          v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                        />
                      </div>
                      <div class="name" style="flex: 9">
                        <div>
                          {{ item.name }}
                        </div>
                        <div class="word">
                          <span @click="look(item)" class="look">预览</span>
                          <span class="down" @click="down(item)">下载</span>
                          <span @click="del(index, 2)" class="del">删除</span>
                        </div>
                      </div>
                    </div>
                    <!--文件上传进度条-->
                    <div class="uploadprocess" v-else>
                      <div>
                        <div class="jdtext">
                          <div class="uploadname">{{ item.name }}</div>
                          <div class="per">{{ item.curPercentage }}%</div>
                        </div>
                        <el-progress
                          :percentage="item.curPercentage"
                          :show-text="false"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="display: flex">
                <el-form-item
                  label="免费凭证"
                  prop="freeFiles"
                  v-if="sfxz.mfpz == true"
                >
                  <el-upload
                    class="upload_file"
                    :show-file-list="false"
                    v-model="form.freeFiles"
                    action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=免费"
                    :before-upload="(file) => beforeUpload(file, 3)"
                    :on-change="(file) => onChange(file, 3)"
                    :on-progress="(event, file) => onProgress(event, file, 3)"
                    multiple
                    :file-list="FileList3"
                    :on-success="
                      (response, file, fileList) =>
                        uploadSuccess(response, file, fileList, 3)
                    "
                    :on-remove="(file) => handleRemove(file, 3)"
                  >
                    <el-button size="small" class="fj_text"
                      >请选择附件</el-button
                    >
                    <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                  </el-upload>
                  <!-- 附件回显 -->
                  <div
                    v-for="(item, index) in FileList3"
                    :key="item.uid"
                    class="file_show"
                    style="margin-top: 10px"
                  >
                    <div class="fj" v-if="!item.isShow">
                      <div style="flex: 1">
                        <img
                          src="../../assets/file/word.svg"
                          v-if="
                            item.ftype == 'doc' ||
                            item.ftype == 'docx' ||
                            item.ftype == 'DOC' ||
                            item.ftype == 'DOCX'
                          "
                        />
                        <img
                          src="../../assets/file/xls.svg"
                          v-if="
                            item.ftype == 'xlsx' ||
                            item.ftype == 'xls' ||
                            item.ftype == 'XLSX' ||
                            item.ftype == 'XLS'
                          "
                        />
                        <img
                          src="../../assets/file/png.svg"
                          v-if="
                            item.ftype == 'jpg' ||
                            item.ftype == 'jpeg' ||
                            item.ftype == 'png' ||
                            item.ftype == 'JPG' ||
                            item.ftype == 'JPEG' ||
                            item.ftype == 'PNG'
                          "
                        />
                        <img
                          src="../../assets/file/PDF.svg"
                          v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                        />
                      </div>
                      <div class="name" style="flex: 9">
                        <div>
                          {{ item.name }}
                        </div>
                        <div class="word">
                          <span @click="look(item)" class="look">预览</span>
                          <span class="down" @click="down(item)">下载</span>
                          <span @click="del(index, 3)" class="del">删除</span>
                        </div>
                      </div>
                    </div>
                    <!--文件上传进度条-->
                    <div class="uploadprocess" v-else>
                      <div>
                        <div class="jdtext">
                          <div class="uploadname">{{ item.name }}</div>
                          <div class="per">{{ item.curPercentage }}%</div>
                        </div>
                        <el-progress
                          :percentage="item.curPercentage"
                          :show-text="false"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="display: flex">
                <el-form-item
                  label="拟出具文件"
                  prop="chujuFiles"
                  v-if="numType == 7||numType == 8||numType == 9"
                >
                  <el-upload
                    class="upload_file"
                    :show-file-list="false"
                    v-model="form.chujuFiles"
                    action="api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&&filetype=拟出具文件"
                    :before-upload="(file) => beforeUpload(file, 4)"
                    :on-change="(file) => onChange(file, 4)"
                    :on-progress="(event, file) => onProgress(event, file, 4)"
                    multiple
                    :file-list="FileList4"
                    :on-success="
                      (response, file, fileList) =>
                        uploadSuccess(response, file, fileList, 4)
                    "
                    :on-remove="(file) => handleRemove(file, 4)"
                  >
                    <el-button size="small" class="fj_text"
                      >请选择附件</el-button
                    >
                    <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                  </el-upload>
                  <!-- 附件回显 -->
                  <div
                    v-for="(item, index) in FileList4"
                    :key="item.uid"
                    class="file_show"
                    style="margin-top: 10px"
                  >
                    <div class="fj" v-if="!item.isShow">
                      <div style="flex: 1">
                        <img
                          src="../../assets/file/word.svg"
                          v-if="
                            item.ftype == 'doc' ||
                            item.ftype == 'docx' ||
                            item.ftype == 'DOC' ||
                            item.ftype == 'DOCX'
                          "
                        />
                        <img
                          src="../../assets/file/xls.svg"
                          v-if="
                            item.ftype == 'xlsx' ||
                            item.ftype == 'xls' ||
                            item.ftype == 'XLSX' ||
                            item.ftype == 'XLS'
                          "
                        />
                        <img
                          src="../../assets/file/png.svg"
                          v-if="
                            item.ftype == 'jpg' ||
                            item.ftype == 'jpeg' ||
                            item.ftype == 'png' ||
                            item.ftype == 'JPG' ||
                            item.ftype == 'JPEG' ||
                            item.ftype == 'PNG'
                          "
                        />
                        <img
                          src="../../assets/file/PDF.svg"
                          v-if="item.ftype == 'pdf' || item.ftype == 'PDF'"
                        />
                      </div>
                      <div class="name" style="flex: 9">
                        <div>
                          {{ item.name }}
                        </div>
                        <div class="word">
                          <span @click="look(item)" class="look">预览</span>
                          <span class="down" @click="down(item)">下载</span>
                          <span @click="del(index, 4)" class="del">删除</span>
                        </div>
                      </div>
                    </div>
                    <!--文件上传进度条-->
                    <div class="uploadprocess" v-else>
                      <div>
                        <div class="jdtext">
                          <div class="uploadname">{{ item.name }}</div>
                          <div class="per">{{ item.curPercentage }}%</div>
                        </div>
                        <el-progress
                          :percentage="item.curPercentage"
                          :show-text="false"
                        ></el-progress>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 收费明细 -->

            <div v-if="false">
              <div v-if="sfxz.detail">
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>收费明细</div>
                </div>
                <el-row class="addrow">
                  <i class="el-icon-plus" @click="addCharge">添加明细</i>
                </el-row>
                <el-row>
                  <el-table
                    class="party"
                    border
                    :data="form.bcbdTable"
                    style="width: 100%"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                  >
                    <el-table-column
                      label="款项名称"
                      prop="Name"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.Name'"
                          :rules="{
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.Name"
                            placeholder="请输入"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="应收金额"
                      prop="Amount"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.Amount'"
                          :rules="{ validator: Price, trigger: 'change' }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.Amount"
                            placeholder="请输入"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="约定收款日期" prop="PaymentDate">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.PaymentDate'"
                          label-width="0"
                        >
                          <el-date-picker
                            style="width: 100%"
                            v-model="scope.row.PaymentDate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请选择日期"
                            :clearable="false"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </template>
                    </el-table-column>

                    <el-table-column label="备注" prop="Remark">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.Remark'"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.Remark"
                            placeholder="请输入"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="状态"
                      prop="Status"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.Status'"
                          label-width="0"
                          :rules="{
                            required: true,
                            message: '不能为空 ',
                            trigger: 'blur'
                          }"
                        >
                          <el-select
                            style="width: 100%"
                            v-model="scope.row.Status"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in Bcbd_status"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button class="copy" @click="copyCharge(scope.row)"
                          >复制</el-button
                        >
                        <el-button
                          class="del_btn"
                          v-if="form.bcbdTable.length > 0"
                          @click="reduceCharge(scope.row.count)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </div>
            </div>
            <!-- 用章申请 -->
            <div class="divider"></div>
            <div class="top">
              <div class="icon"></div>
              <div>用章申请</div>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form
                  class="form"
                  ref="sealForm"
                  :model="form.sealForm"
                  :rules="sealRules"
                  label-width="200px"
                >
                  <el-col :span="12">
                    <el-form-item label="申请人" prop="applicant">
                      <el-select
                        v-model="form.sealForm.applicant"
                        placeholder="请选择"
                        class="input"
                        filterable
                        @change="SealLawyer()"
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="用章事由" prop="reason">
                      <el-input
                        placeholder="请输入"
                        v-model="form.sealForm.reason"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-form-item
                    v-if="false"
                    label="部门主管"
                    prop="sealLeaders"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.sealForm.sealLeaders"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in SealLeaders"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="false"
                    label="二次审批人"
                    prop="leadLawyer2"
                  >
                    <el-select
                      v-model="form.sealForm.leadLawyer2"
                      style="width: 100%"
                      placeholder="请选择"
                      class="select"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in SealLevel"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item v-show="false" label="附件" prop="sealFile">
                    <el-select
                      v-model="form.sealForm.sealFile"
                      placeholder="请选择"
                      class="input"
                      style="width: 100%"
                      multiple
                      filterable
                    >
                      <el-option
                        v-for="item in FileList"
                        :key="item.uid"
                        :label="item.name"
                        :value="item.uid"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="16" v-show="false">
                <div style="margin-left: 10%">
                  <div>支持导出的材料：</div>
                  <div style="display: flex">
                    <div>
                      <el-checkbox-group
                        v-model="form.sealForm.checkedCities"
                        @change="handleCheckedCitiesChange"
                      >
                        <el-checkbox
                          style="display: block; padding-top: 20px"
                          v-for="city in form.sealForm.cities"
                          :label="city.name"
                          :key="city.name"
                          >{{ city.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <div>
                      <div
                        style="margin-left: 15%; padding-top: 12px"
                        v-for="city in form.sealForm.cities"
                      >
                        <el-select
                          size="mini"
                          v-model="city.stype"
                          placeholder="请选择用章类型"
                          class="yz_input"
                          @change="GetSealLevel()"
                          clearable
                          filterable
                          multiple
                        >
                          <el-option
                            v-for="item in Seal"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </el-col>
            </el-row>

            <!-- 关联案件 -->
            <div class="divider"></div>
            <div class="top">
              <div class="icon"></div>
              <div>关联案件</div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="关联案件" prop="linkId">
                  <el-select
                    popperClass="custom-popper"
                    style="width: 100%"
                    v-model="form.linkId"
                    placeholder="请选择"
                    class="select"
                    clearable
                    filterable
                    :disabled="sup"
                    :remote-method="GetCaseLink"
                    remote
                    :loading="caseLinkloading"
                  >
                    <el-option
                      v-for="item in Caselevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="allbtn">
            <el-button type="warning" @click="saveCaoGao()">
              保存草稿
            </el-button>
            <el-button
              type="primary"
              @click="inputCase('formref')"
              :disabled="dianji"
              >确认提交</el-button
            >
            <el-button class="history" @click="history">返回</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 案件冲突 -->
    <el-dialog
      title="冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="edit"
    >
      <el-form  ref="formConflict" :model="formConflict" label-width="150px" :rules="rulesConflict">
        <el-row v-if="conflictShow" >
        <el-col :span="8">
          <el-form-item label="二次利冲审批人" prop="conflictApproval" >
              <el-select
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                style=" width: 100%;"
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="OptiomConflict.length<1&&allConflictCount>0" style="color:red;font-size:18px; margin-bottom:12px;">暂无二次利冲审批人，无法录入</div>
      <h2>
        顾问冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="lvShiConflict"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        
      >
        <el-table-column prop="unitName" label="顾问单位">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.unitName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
        <el-table-column prop="lawyer" label="承办律师"> </el-table-column>

        <el-table-column prop="unitType" label="单位性质"> </el-table-column>
        <el-table-column prop="endTime" label="到期时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.endTime) }}
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <br />
      <h2>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="conflictList"
        style="width: 100% ; height:200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[3]" class="litigant-container">
              {{ scope.row.litigant[3].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[3].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[3].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[4]" class="litigant-container">
              {{ scope.row.litigant[4].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[4].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[4].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[5]" class="litigant-container">
              {{ scope.row.litigant[5].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[5].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[5].all.length - 1"
                  >,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <!-- <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button @click="conflictClick(scope.row)" v-if="!scope.row.isOther"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
       <div v-if="dialoghasMore" style="text-align: center;">
          <el-button  type="text" @click="dialogshowAllCaseClick" >
            {{ dialogshowAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>
      <br />
      <br />
      <br />
      <h2>
        破产管理人冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="BanruptcykConflict"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        
      >
        <el-table-column prop="name" label="破产企业名称">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号"> </el-table-column>
        <el-table-column prop="soure" label="破产项目来源"> </el-table-column>
         <el-table-column prop="mainName" label="代理律师(主)"> </el-table-column>
          <el-table-column prop="deputyName" label="代理律师(副)">
             <template slot-scope="scope">
    {{ scope.row.deputyName ? scope.row.deputyName.join('、') : '' }}
  </template>
   </el-table-column>
        
        <el-table-column prop="collectionDate" label="收案日期">
          <template slot-scope="scope">
            {{ formatTime(scope.row.collectionDate) }}
          </template>
        </el-table-column>
      </el-table>
     
      <div class="conflic_btn">
        <el-button @click="conflict('formConflict')" type="primary" :disabled="dianji" v-if="!(allConflictCount>0&&OptiomConflict.length<=0)"
          >继续录入</el-button
        >
        <el-button type="warning" @click="edit()">取消录入</el-button>
      </div>
    </el-dialog>

     <!-- 冲突预览 -->
     <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6||chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <!-- <el-row class="addrow" v-if="bianji == false">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="mini" type="primary" @click="addParty(null, null)">
              添加当事人
            </el-button>
          </el-row> -->
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
                v-if="chongCaseType != 9"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="身份证号/社会信用代码/护照号"
                prop="idnumber"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

            
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9&&chongCaseType!=11">
            <el-col :span="12">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="12" v-if="chongCaseType != 10">
                    <el-form-item label="身份证号/社会信用代码/护照号" >
                      <el-input v-model="CTform.bcz.idnumber" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>

           <el-row v-if="chongCaseType==11" v-for="(item,index) in CTform.bcz.tableData">
            <el-col :span="12">
              <el-form-item label="客户名称" :prop="`bcz.tableData[${index}].name`" v-if="chongCaseType==11">
                      <el-input
                        v-model="CTform.bcz.tableData[index].name"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="12">
                    <el-form-item label="身份证号/社会信用代码/护照号"  :prop="`bcz.tableData[${index}].idnumber`"  label-width="260px">
                      <el-input v-model="CTform.bcz.tableData[index].idnumber" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- 预览dialog -->
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      center
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <!-- 草稿 -->
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        检测到当前案件类型有草稿存在，是否基于草稿继续录入？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="caoGaoInput()">基于草稿录入</el-button>
        <el-button type="primary" @click="inputDraftNew(true)"
          >全新录入</el-button
        >
        <el-button type="danger" @click="deleteCaoGao()"
          >管理当前案件类型草稿</el-button
        >
      </span>
    </el-dialog>

    <!-- 草稿选择 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="cgDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="cgid"
          class="all-select"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.name"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cgDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="cgInput(cgid)">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 草稿管理 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="scDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="scid"
          class="all-select"
          clearable
          placeholder="请选择您要删除的草稿"
          multiple
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.name"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="scCG(scid)">删 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  getCaseLinkApi,
  caseInputApi,
  caseConflictApi,
  caseLawyerApi,
  caseAdviserApi,
  caseDepartmentLeadersApi,
  allCaseApi,
  getLitigant,
  ConflictMember,
  GetAllLitigant,
  BanruptcykConflictApi
} from '../../api/case'
import { requestDownLoadFile } from '../../api/seal.js'

import {
  requestDownLoadFile as YuLan,
  requestReview
} from '../../api/counsel.js'
import mammoth from 'mammoth'
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'caseinput',

  data() {
    var Price = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }

    var newPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }

    var riskRatio = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('不能小于'))
      } else if (value > 100) {
        callback(new Error('不能大于100'))
      } else if (!price.test(value)) {
        callback(new Error('最多输入两位小数')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }

    var filecheck = (rule, value, callback) => {
      if (
        value == null ||
        value === undefined ||
        value == '' ||
        value == [] ||
        value.length <= 0
      ) {
        callback(new Error('至少要上传一个附件！'))
      }
      callback()
    }
    return {
      AllLit:[],
      Level: [
        { value: 1, label: '一级' },
        { value: 2, label: '二级' },
        { value: 3, label: '三级' }
      ], //案件级别
      Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
    ProjectType:[{label:"重整案件",value:"重整案件"},{label:"预重整",value:"预重整"},{label:"公益案件",value:"公益案件"}],  
      isTrue:true,
      isFalse:false,
      // 案件审核主管
      CaseLeaders: [],

      // 用章审核主管
      SealLeaders: [],

      // 表单验证
      rules: {
        casestatus: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        name: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        // acceptcode: [
        //   { required: true, validator: ajstatusCheck, trigger: 'blur' },
        //   { required: true, validator: ajstatusCheck, trigger: 'change' }
        // ],
        cause: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        acceptUnit: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        ajstatus: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        approvaldate: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        leadLawyer: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        chargingMethod: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        level: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' }
          // { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        leadLawyer2: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' }
          // { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        criminalrisk: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        caseLeaders: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
          // { required: true, message: '请选择主管', trigger: 'change' }
        ],
        caseLeaders1: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
          // { required: true, message: '请选择主管', trigger: 'change' }
        ],
        amountOfSubject: [
          { required: true, validator: newPrice, trigger: 'change' }
        ],
        //投标价格
        fixed: [{ required: true, validator: newPrice, trigger: 'change' }], //定额收费金额
        riskFixed: [{ required: true, validator: newPrice, trigger: 'change' }], //半风险中的定额收费金额
        riskRatio: [{ required: true, validator: newPrice, trigger: 'change' },
        { validator: riskRatio, trigger: 'change' }
      ], //风险收费比例

        biddingSchemes: [
          { required: true, validator: filecheck, trigger: 'blur' }
        ],
        chujuFiles: [{ required: true, validator: filecheck, trigger: 'blur' }],
        freeFiles: [{ required: true, validator: filecheck, trigger: 'blur' }],
        IsUnit: [{ required: true, message: '不能为空', trigger: 'blur' }],
        Name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        Idnumber: [{ required: true, message: '不能为空', trigger: 'blur' }],
        IsClient: [{ required: true, message: '不能为空', trigger: 'blur' }],
        Attribute: [{ required: true, message: '不能为空', trigger: 'blur' }]
        // procureunit: [
        //   { required: true, validator: ajstatusCheck, trigger: 'blur' },
        //   { required: true, validator: ajstatusCheck, trigger: 'change' }
        // ]
      },

      sealRules: {
        applicant: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        // seal: [
        //   { required: true, validator: ajstatusCheck, trigger: 'blur' }
        //   // { required: true, validator: ajstatusCheck, trigger: 'change' }
        // ],
        reason: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' },
          { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        leadLawyer2: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' }
          // { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        sealLeaders: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' }
          // { required: true, validator: ajstatusCheck, trigger: 'change' }
        ],
        sealFile: [
          { required: true, validator: ajstatusCheck, trigger: 'blur' }
          // { required: true, validator: ajstatusCheck, trigger: 'change' }
        ]
      },

      // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '破产申请', value: '破产申请' },
        { label: '再审听证', value: '再审听证' },
        { label: '强制清算', value: '强制清算' },
        { label: '行政复议', value: '行政复议' },
        { label: '行政裁决', value: '行政裁决' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' },
        { label: '无', value: '无' },
        { label: '申请撤销裁决', value: '申请撤销裁决' },
      ],
      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ],
      // 委托事项
      Entrust: [
        { value: '特别授权', label: '特别授权' },
        { value: '一般授权', label: '一般授权' }
      ],
      // 收费方式
      Chargestatus1: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ],
      Chargestatus2: [//刑事案件专属
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
      ],
      Chargestatus:[],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      SealChange: [
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      // 关联案件
      Caselevel: [],
      // 公益诉求
      options: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
      //是否代理
      isClient: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ],
      // 身份
      ArrtibuteOptions: [
        // { value: '原告', label: '原告' },
        // { value: '被告', label: '被告' },
        // { value: '第三人', label: '第三人' },
        // { value: '上诉人', label: '上诉人' },
        // { value: '被上诉人', label: '被上诉人' },
        // { value: '原审第三人', label: '原审第三人' },
        // { value: '原审原告', label: '原审原告' },
        // { value: '原审被告', label: '原审被告' },
        // { value: '申请人', label: '申请人' },
        // { value: '被申请人', label: '被申请人' },
        // { value: '债务人', label: '债务人' },
        // { value: '债权人', label: '债权人' },
        // { value: '公诉机关', label: '公诉机关' },
        // { value: '犯罪嫌疑人', label: '犯罪嫌疑人' },
        // { value: '自诉人', label: '自诉人' },
        // { value: '复议申请人', label: '复议申请人' },
        // { value: '复议被申请人', label: '复议被申请人' },
        // { value: '申请执行人', label: '申请执行人' },
        // { value: '被执行人', label: '被执行人' },
        // { value: '执行异议人', label: '执行异议人' }
      ],

      xingshiArrtibute1: [
        { value: '被告人', label: '被告人', order: 100 },
        { value: '上诉人', label: '上诉人', order: 200 },
        { value: '犯罪嫌疑人', label: '犯罪嫌疑人', order: 300 }
      ],

      xingshiArrtibute2: [
        { value: '公诉机关', label: '公诉机关', order: 400 },
        { value: '自诉人', label: '自诉人', order: 500 }
      ],

      ershenArrtibute: [
        { value: '第三人', label: '第三人', order: 300 },
        { value: '原审第三人', label: '原审第三人', order: 400 }
      ],

      // 介入阶段
      Intervene: [
        { value: '0', label: '全程' },
        { value: '1', label: '侦查阶段' },
        { value: '2', label: '审查起诉阶段' },
        { value: '3', label: '审判阶段' }
      ],

      // 项目类型
      Projecttype: [
        { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }
      ],
      // 收费明细状态
      Bcbd_status: [
        // { value: -1, label: '已删除' },
        { value: 0, label: '已完成' },
        // { value: 1, label: '已禁用' },
        { value: 2, label: '已提醒' },
        { value: 3, label: '待提醒' }
      ],
      // 底稿资料
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ],
      // 代理律师/申请人/代理律师
      Lawyer: [],
      // 案件二次审批人
      Level: [],
      //用章二次审批人
      SealLevel: [],
      // 风控委
      FKW: [],
      // 刑事风险控制人
      Criminal: [],

      // 表单
      form: {
        casestatus: null, //受理状态
        acceptcode: null, // 受理机构案号/受理案号
        assist: null, //法律援助(true是，false否）
        caseType: null, // 录入类型/案件类型
        name: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案件类型(节点名称)******
        // approvaldate: null, //收案日期(委托时间)******
        acceptUnit: null, //受理机构(受理单位)
        source: null, // 项目来源/案件来源
        cause: null, //案由/项目概要
        leadLawyer: [], //代理律师(主办律师)******
        remark: null, //委托事项
        level: [], //二次审批人/风控委
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        chujuFiles: [], // 拟出具文件
        ordinaryFiles: [], //普通附件 List
        freeFiles: [], // 免费凭证
        linkId: null, // 关联案件ID

        criminalrisk: null, //刑事风险控制人  Guid
        caseLeaders: null, // 案件部门主管
        //------全都是<非诉案件>------

        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null, //采购单位/客户名称
          idnumber:null,//身份证号/社会信用代码
          tableData:[
            {
              id:null,
              name: null, //姓名/单位名称***
              attribute: "客户名称", //当事人属性（原告被告等）***
              count: 1,
              idnumber:null,
              isClient:true,
              isUnit:false,
              order:0,
              }
          ],//只有专项服务合同才有
        },

        // 收费
        chargingMethod: '固定收费', //收费方式******
        subjectMatter: null, //案件标的
        amountOfSubject: 0, //标的金额******
        introduction: null, //简介
        sf_remark: null, //备注
        fixed: 0, //固定收费金额******
        riskFixed: 0, //半风险定额收费金额******
        riskRatio: 0, //风险收费比例******

        // 收费明细
        bcbdTable: [
          // {
          //   Name: null, // 款项名称******
          //   Amount: null, // 应收金额******
          //   PaymentDate: null, //约定收款日期
          //   Remark: null, //备注
          //   Status: null, // 状态******
          //   count: 1
          // }
        ],
        // 案件当事人
        tableData: [
          // {
          //   IsUnit: null, //是否是个人******
          //   Name: null, //姓名/单位名称******
          //   IsClient: false, //是否委托人******
          //   Attribute: null, //当事人属性（原告被告等）******
          //   count: 1
          // }
        ],

        sealForm: {
          // ------用章申请------
          sealFile: [], //附件
          applicant: null, //申请人******
          leadLawyer2: null, //二次审批人
          seal: null, //用章类型******
          reason: '申请立项', //用章事由******\
          sealLeaders: null, // 用章部门主管

          cities: null,
          checkedCities: []
        },
        draftFormId: null,
        draftFormType: null,
        uuid: null
      },

      newbcbdTable: [],

      newtableData: [],

      sfxz: {
        // 定额收费金额
        fixed: true,

        // 半风险中的定额收费金额
        riskFixed: false,

        // 风险收费比例
        riskRatio: false,

        // 收费明细
        detail: true,

        // 免费附件
        mfpz: false
      },
      FileList1: [],
      FileList2: [],
      FileList3: [],
      FileList4: [],
      isShowJinDuTiao: false, //上传进度招标文件
      isShowother: false, //上传进度普通文件
      curPercentage: 0, //进度百分比
      uploadname: null, //正在上传的文件名称
      type: [], //项目类型

      titleType: null, // 录入类型标题

      numType: null, // 类型判断参数
      FileList: [], //用章附件
      Arr: [], //律师冲突变量
      caseConflict: false, //案件冲突状态
      conflictList: [], //案件冲突列表
      lvShiConflict: [], //顾问冲突列表
      sup: false,
      ProcessType: ['case_entry'],
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      bianji: true, // 只允许不通过的时候编辑（false可编辑，true不能）
      //冲突详情
      chongCaseType: '',
      isChong: false,
      //是否代理
      IsClient: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ],
      CTform: {
        casestatus: null,
        acceptcode: null, // 受理机构案号/受理案号
        id: null,
        assist: null, //法律援助(true是，false否）
        typeId: null, // 录入类型
        title: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案卷状态(节点名称)***
        approvaldate: null, //收案日期(委托时间)***
        source: null, // 项目概要/案件来源
        acceptUnit: null, //受理机构(受理单位)
        cause: null, //案由/项目来源
        leadLawyer: [], //代理律师(主办律师)***List
        remark: null, //委托事项
        level: [], //二次审批人/风控委
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        chujuFiles: [], // 拟出具文件
        ordinaryFiles: [], //普通附件 List
        invoiceFile: [], //发票
        linkId: null, // 关联案件ID*** Guid
        status: null,
        caseLeaders: null, // 案件部门主管
        link: [],
        criminalrisk: null, //刑事风险控制人  Guid
        result: null,
        bs_Result: null,
        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null, //采购单位/客户名称
          projecttype:null,
          idnumber:null,
        },
        // 案件当事人
        tableData: [
          {
            id: null,
            isUnit: null, //是否是个人***
            name: null, //姓名/单位名称***
            IsClient: false, //是否委托人***
            attribute: null, //当事人属性（原告被告等）***
            count: 1,
            idnumber:null,
            order:0,
          }
        ]
      },

      centerDialogVisible: false,
      cgDialogVisible: false,
      caoGao1: false,
      newcaoGao1: false,
      caoGao: [],
      caoGaoSeal: [],
      cgid: null,
      loading: true,
      my: false,
      scDialogVisible: false,
      scid: null,
      addTableData: null,
      caseLinkloading: false,

      restaurants: [],
      allrestaurants: null,
      dianji: false,

      //二次利冲审批人
      conflictShow:false,//是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount:0,//总冲突数量
      OptiomConflict:[],//所有二次利冲审批人
      formConflict:{
        conflictApproval:null,
      },
      rulesConflict:{
        conflictApproval: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },


      dialogshowAllCase:false,//是否显示全部冲突案件
      dialoghasMore:false,
      dialogallConflictCase:[],//所有的冲突案件

      idnumbers:[],
      BanruptcykConflict:[],
    }
  },

  methods: {
     filterComma3(row) {
      if (row.name&&row.name.includes('、')) {
        row.name = row.name.replace(/、/g, '');
      }
      if (row.idnumber&&row.idnumber.includes('、')) {
        row.idnumber = row.idnumber.replace(/、/g, '');
      }
    },
    //客户名称
    querySearchName3(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
  handleSelectName3(item,index){
   this.form.bcz.tableData[index].name=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.bcz.tableData[index].idnumber=unique1[0]
    }
  },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId3(queryString, cb) {
     
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = this.idnumbers.map(id => ({ value: id }));
    // console.log(this.idnumbers)
      
      var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
      cb(results);
    },

   // 添加当事人
    addParty3() {
      
      // 当前已有的最大count
      let c = Math.max.apply(
        Math,
        this.form.bcz.tableData.map(function (f) {
          return f.count
        })
      )
      var td=this.form.bcz.tableData.length
      if (c === undefined) {
        if (td == 0) {
          this.form.bcz.tableData.push({
            // 表格
            isUnit: false,
            name: null,
            idnumber:null,
            isClient: true,
            attribute: "客户名称",
            count: 0,
            order: 0
          })
        } else {
          this.form.bcz.tableData.splice(td, 0, {
            // 表格
             isUnit: false,
              name: null,
              idnumber:null,
              isClient: true,
              attribute: "客户名称",
              count: c + 1,
              order: 0,
          })
        }
      } else {
        this.form.bcz.tableData.splice(td, 0, {
          // 表格
           isUnit: false,
              name: null,
              idnumber:null,
              isClient: true,
              attribute: "客户名称",
              count: c + 1,
              order: 0,
        })
      }
    // console.log(this.form.bcz.tableData,td)
      // this.form.tableData.sort((a, b) => {
      //   return a.order - b.order
      // })

      // this.getLitigants()
    },

    // 减少当事人
    reduceParty3(c) {
     
      // 最少保留1行，防止删空
      if (this.form.bcz.tableData.length <= 1) {
        this.$message.warning('至少保留一条数据');
        return;
      }
      // splice(起始下标, 删除个数)
      this.form.bcz.tableData.splice(c, 1);

    },

    GetLit(){//获取所有当事人
      GetAllLitigant({}).then((res)=>{
        if(res.data.status=='success'){
          this.AllLit=res.data.data
        }else{
          this.AllLit=[]
        }
       })
    },
    //客户名称
    querySearchName2(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
  handleSelectName2(item){
    this.form.bcz.procureunit=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.bcz.idnumber=unique1[0]
    }
  },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId2(queryString, cb) {
     
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = this.idnumbers.map(id => ({ value: id }));
    // console.log(this.idnumbers)
      
      var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
      cb(results);
    },

    // 选中证件号的处理（可选）
    handleSelectId2(id) {
      this.form.bcz.idnumber = id.value; // 赋值选中的证件号
    },
    
    querySearchName(queryString, cb,row) {
     
       var restaurants =[]
       
       if((row.IsUnit==false&&this.numType!=9)||(queryString.length>4&&this.numType==9)){
        restaurants = this.AllLit;
       }
       var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
     
      // console.log(queryString)
       if(results.length==0&&row&&row.availableIdnumbers){
          row.availableIdnumbers=[]
       }
          // 调用 callback 返回建议列表的数据
       cb(results);
      },
      createFilterName(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
    handleSelectName(item, row){
      row.Name = item.value
      const unique1 = [...new Set(item.idnumber)];
      row.availableIdnumbers = unique1;
     
      if(unique1&&unique1.length>0){
        row.Idnumber=unique1[0]
      }
    },
     // 身份证号搜索逻辑：基于当前行的候选证件号
     querySearchId(queryString, cb, row) {
      // 候选源为当前姓名对应的证件号（若未选姓名则为空）
      var idCandidates = [];
      
      if(row.availableIdnumbers){
        idCandidates=row.availableIdnumbers.map(id => ({ value: id }))
        var results = queryString ? idCandidates.filter(this.createFilterName(queryString)) : idCandidates;
        cb(results);
      }else{
        cb(idCandidates);
      }
      
    
    },

    // 选中证件号的处理（可选）
    handleSelectId(id, row) {
      row.Idnumber = id.value; // 赋值选中的证件号
    },
    

    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    //禁止顿号的输入
    filterComma(row) {
      if (row.Name && row.Name.includes('、')) {
        row.Name = row.Name.replace(/、/g, '');
       
      }
      if (row.Idnumber && row.Idnumber.includes('、')) {
        row.Idnumber = row.Idnumber.replace(/、/g, '');
      }
    },
    filterComma2(row) {
      if (row.procureunit&&row.procureunit.includes('、')) {
        row.procureunit = row.procureunit.replace(/、/g, '');
      }
      if (row.idnumber&&row.idnumber.includes('、')) {
        row.idnumber = row.idnumber.replace(/、/g, '');
      }
    },
   
    dialogshowAllCaseClick(){
      if(this.dialogshowAllCase){
        this.dialogshowAllCase=false
        this.conflictList = this.dialogallConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.conflictList.length==0){//没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0])
        } 
       
      }else{
        this.conflictList=this.dialogallConflictCase
        this.dialogshowAllCase=true
      }
    },
    //获取二次利冲审批人
   async GetConflictMember(){
      ConflictMember().then((res) => {
        if(res.data.status=="success"){
          this.OptiomConflict=res.data.data
          this.caseConflict = true
                 
          if(this.OptiomConflict.length>1){
            this.conflictShow=true
          }else if(this.OptiomConflict.length==1){
             this.conflictShow=false
             this.formConflict.conflictApproval=this.OptiomConflict[0].value
          }
            // console.log( this.conflictShow)
        }else{
          this.$message.error(res.data.message)
        }
      })
    },

    //原来获取对应属性且对应律师的案件当事人
    getLitigants() {
      var newAtt = []
      this.form.tableData.forEach((v) => {
        newAtt.push(v.Attribute)
      })
      newAtt = [...new Set(newAtt)]
      getLitigant({
        casetype: this.$route.query.status,
        attribute: newAtt
      })
        .then((res) => {
          this.allrestaurants = res.data.data
        })
        .catch((err) => {
          console.log('错误', err)
        })
    },
    handleSelect(item, row) {
      row.Attribute = item.att
      row.IsClient = item.client
      row.IsUnit = item.unit
      row.Name = item.value
      row.Idnumber=item.idnumber
    },
    querySearch(queryString, cb, row) {
      const attCount = this.allrestaurants.length
      // console.log("1",this.allrestaurants)
      if (attCount > 0) {
        this.restaurants = []
        for (let i = 0; i < attCount; i++) {
          // console.log('this.allrestaurants[i][0]', this.allrestaurants[i][0])
          if (this.allrestaurants[i][0] != undefined) {
            if (this.allrestaurants[i][0].key.att == row.Attribute) {
              this.allrestaurants[i].forEach((v) => {
                this.restaurants.push(v.key)
              })
            }
          }
        }
      }
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },

    sfbt(a) {
      if (
        a == '原告' ||
        a == '被告' ||
        a == '上诉人' ||
        a == '被上诉人' ||
        a == '申请人' ||
        a == '被申请人' ||
        a == '债务人' ||
        a == '被告人' ||
        a == '犯罪嫌疑人' ||
        a == '自诉人' ||
        a == '公诉机关' ||
        a == '复议申请人' ||
        a == '复议被申请人' ||
        a == '申请执行人' ||
        a == '被执行人' ||
        a == '客户名称' ||
        a == '对方当事人'
      ) {
        return '是'
      } else {
        return '否'
      }
    },
    // 代理改变事件
    clientChange(row) {
      // 民事
      if (this.numType == 1) {
        if (this.form.ajstatus == '一审') {
          if (row.Attribute == '原告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '原告') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.Attribute == '上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被上诉人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '上诉人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审'||this.form.ajstatus=='申请撤销裁决') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus == '强制清算') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '破产申报') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '债务人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '债务人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }else if (row.Attribute == '债权人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人'||v.Attribute=='债务人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '破产申请') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行') {
          if (row.Attribute == '申请执行人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被执行人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被执行人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请执行人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '审判监督(再审)') {
          if (row.Attribute == '再审申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '再审被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '再审被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '再审申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '公示催告') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '支付人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '支付人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '督促') {
          if (row.Attribute == '债权人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '债务人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '债务人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '债权人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '选民资格案件(特别)') {
          if (row.Attribute == '起诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '选举委员会') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '选举委员会') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '起诉人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '原财产所有人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '原财产所有人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus == '制定遗产管理人案件(特别)' ||
          this.form.ajstatus == '确认调解协议案件(特别)' ||
          this.form.ajstatus == '实现担保物权案件(特别)' ||
          this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)' ||
          this.form.ajstatus == '认定公民无民事行为能力、限制行为能力案件(特别)'
        ) {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        }
      }
      // 刑事
      else if (this.numType == 2) {
        if (
          this.form.ajstatus == '侦查' ||
          this.form.ajstatus == '审查起诉'
        ) {
          if (row.Attribute == '犯罪嫌疑人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被害人') {
                  v.IsClient = false
                }
              })
            }
          } else  if (row.Attribute == '被害人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '犯罪嫌疑人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '公诉机关') {
            if (row.IsClient) {
              row.IsClient = false
              this.$message.error('不能代理' + row.Attribute)
            }
          }
        } else if (this.form.ajstatus == '法院审理(一审)') {
          if (row.Attribute == '被告人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被害人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被害人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '公诉机关') {
            if (row.IsClient) {
              row.IsClient = false
              this.$message.error('不能代理' + row.Attribute)
            }
          }
          
        } else if (this.form.ajstatus == '被告人上诉(二审)') {
          if (row.Attribute == '上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被害人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被害人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '上诉人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '检察机关') {
            if (row.IsClient) {
              row.IsClient = false
              this.$message.error('不能代理检察机关')
            }
          }
        } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
          if (row.Attribute == '抗诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                // if (v.Attribute == '被抗诉人') {
                //   v.IsClient = false
                // }
                if (v.Attribute == '原审被告人') {
                  v.IsClient = false
                }
              })
            }
          }
          else if (row.Attribute == '原审被告人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '抗诉人') {
                  v.IsClient = false
                }
              })
            }
          }
          //  else if (row.Attribute == '被抗诉人') {
          //   if (row.IsClient) {
          //     this.form.tableData.forEach((v) => {
          //       if (v.Attribute == '抗诉人') {
          //         v.IsClient = false
          //       }
          //     })
          //   }
          // }
        } else if (this.form.ajstatus == '再审') {
          if (row.Attribute == '再审申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '再审被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '再审被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '再审申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '自诉案件') {
          if (row.Attribute == '自诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被告人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '自诉人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '刑事附带民事诉讼') {
          if (row.Attribute == '刑事附带民事诉讼原告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '刑事附带民事诉讼被告') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '刑事附带民事诉讼被告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '刑事附带民事诉讼原告') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '涉及单位犯罪') {
          if (row.Attribute == '被告人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被害人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被害人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (
          this.form.ajstatus ==
            '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          this.form.ajstatus == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        }
      }
      // 行政
      else if (this.numType == 3) {
        // console.log(this.form.ajstatus)
        if (this.form.ajstatus == '一审') {
          if (row.Attribute == '原告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审') {
          if (row.Attribute == '上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被上诉人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '上诉人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '再审') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政裁决') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政复议') {
          if (row.Attribute == '复议申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '复议被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '复议被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '复议申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '一审(行政诉讼)') {
          if (row.Attribute == '原告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被告') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被告') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '原告') {
                  v.IsClient = false
                }
              })
            }
          }else if (row.Attribute == '请求人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '权利人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '权利人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '请求人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '二审(行政诉讼)') {
          if (row.Attribute == '上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被上诉人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被上诉人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '上诉人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '申请再审(行政诉讼)') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '执行阶段(行政诉讼)') {
          if (row.Attribute == '申请执行人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请执行人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请执行人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请执行人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政处罚') {
          if (row.Attribute == '当事人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '行政主体') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '行政主体') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '当事人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政许可') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被许可人') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被许可人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '行政强制') {
          if (row.Attribute == '当事人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '行政主体') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '行政主体') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '当事人') {
                  v.IsClient = false
                }
              })
            }
          }
        } else if (this.form.ajstatus == '政府信息公开') {
          if (row.Attribute == '申请人') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '被申请机关') {
                  v.IsClient = false
                }
              })
            }
          } else if (row.Attribute == '被申请机关') {
            if (row.IsClient) {
              this.form.tableData.forEach((v) => {
                if (v.Attribute == '申请人') {
                  v.IsClient = false
                }
              })
            }
          }
        }
      }
      // 执行
      else if (this.numType == 4) {
        if (row.Attribute == '申请执行人') {
          if (row.IsClient) {
            this.form.tableData.forEach((v) => {
              if (v.Attribute == '被执行人') {
                v.IsClient = false
              }
            })
          }
        } else if (row.Attribute == '被执行人') {
          if (row.IsClient) {
            this.form.tableData.forEach((v) => {
              if (v.Attribute == '申请执行人') {
                v.IsClient = false
              }
            })
          }
        }
      }
      // 仲裁
      else if (this.numType == 5 || this.numType == 6) {
        if (row.Attribute == '申请人') {
          if (row.IsClient) {
            this.form.tableData.forEach((v) => {
              if (v.Attribute == '被申请人') {
                v.IsClient = false
              }
            })
          }
        } else if (row.Attribute == '被申请人') {
          if (row.IsClient) {
            this.form.tableData.forEach((v) => {
              if (v.Attribute == '申请人') {
                v.IsClient = false
              }
            })
          }
        }
      }
    },

    handleCheckedCitiesChange(row) {},
    getRandomColor1(show) {
      if (show==1) return '#e86e30'
      else return 'blue'
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h('span', { style: 'color: red' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
    Price(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于等于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },
    close() {
      this.imgUrl = ''
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.loading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          //Image PDF
          YuLan({ Id: item.uid }).then((res) => {
            if (res.data.type.includes('application/json') && res.data.type) {
              this.handlerResponseError(res.data)
            } else {
              this.isWord = false
              this.isExcel = false
              this.isImage = true
              this.dialogVisible = true
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          var vm = this
          //WORD

          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.dialogVisible = true
              this.isWord = true
              this.isExcel = false
              this.isImage = false
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.dialogVisible = true
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.loading = false
      } else {
        this.loading = false
        this.$message.error('不支持此文件预览')
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          } // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
    },
    async down(item) {
      //下载
      const res = await requestDownLoadFile({
        Id: item.uid
      })
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = null
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      }
      return url
    },
    del(index, type) {
      if (type == 1) {
        this.FileList1.splice(index, 1)
      } else if (type == 2) {
        this.FileList2.splice(index, 1)
      } else if (type == 3) {
        this.FileList3.splice(index, 1)
      } else if (type == 4) {
        this.FileList4.splice(index, 1)
      }
      this.FileList = this.FileList1.concat(this.FileList2)
      this.form.sealForm.sealFile = []
    },
    handleRemove(file, type) {
      //删除附件
      if (type == 1) {
        this.FileList1.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value, index, array) => {
          //删除上传失败的文件
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }
      this.FileList = this.FileList1.concat(this.FileList2)
    },
    onProgress(event, file, type) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      if (type == 1) {
        this.FileList1.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }
      this.FileList = this.FileList1.concat(this.FileList2)
    },
    onChange(file, type) {
      if (file.status == 'fail') {
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        this.FileList = this.FileList1.concat(this.FileList2)
        return this.$message.error(file.name + '上传失败')
      }
    },
    beforeUpload(file, type) {
      var fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      //上传验证
      if (type == 1) {
        this.FileList1.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 2) {
        this.FileList2.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 3) {
        this.FileList3.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 4) {
        this.FileList4.push({
          uid: file.uid,
          //name: file.name.split('.')[0],
          name: file.name.substring(0, file.name.lastIndexOf('.')),
          ftype: fileType,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      this.uploadname = file.name
      // var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isImg =
        '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.pdf,.PDF,.wps,.WPS'.indexOf(
          fileType
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf,wps格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      if (res.status == '0') {
        let l = file.response.data.substring(
          file.response.data.lastIndexOf('=') + 1
        )
        if (type == 1) {
          this.FileList1.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = l
            }
          })
          this.FileList.push(this.FileList1)
        } else if (type == 2) {
          this.FileList2.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = l
            }
          })
          this.FileList.push(this.FileList2)
        } else if (type == 3) {
          this.FileList3.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = l
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = l
            }
          })
        }
        this.FileList = this.FileList1.concat(this.FileList2)
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      } else {
        //删除附件
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        this.$message.error('上传失败！')
      }
    },
    history() {
      var _this = this
      _this.$router.go(-1)
      setTimeout(() => {
        var r = _this.$route
        if (
          _this.$route.path == '/home/case/myCase' ||
          _this.$route.path == '/home/case/allCase' ||
          _this.$route.path == '/home/case/filedCase'||
          _this.$route.path == '/home/case/AllBankruptCase'
        ) {
          _this.$store.commit('setinputstatus', 0)
        } else {
          _this.$store.commit('setinputstatus', 1)
          if (r.path == '/home/case/caseinfo') {
            // _this.$router.go(0)
            window.location.reload()
          }
        }
      }, 1000)
    },

    //立项日历
    onMouseOver() {
      if (this.form.approvaldate != undefined && this.form != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },

    dsrOrder(row) {
      if (this.numType == 2) {
        if (
          row.Attribute == '被告人' ||
          row.Attribute == '上诉人' ||
          row.Attribute == '犯罪嫌疑人'
        ) {
          var nat = this.xingshiArrtibute1.filter(
            (item) => item.label == row.Attribute
          )
          row.order = nat[0].order
        } else if (row.Attribute == '公诉机关' || row.Attribute == '自诉人') {
          var nat = this.xingshiArrtibute2.filter(
            (item) => item.label == row.Attribute
          )
          row.order = nat[0].order
        }
      } else if (
        ((this.numType == 1 && this.form.ajstatus == '二审') ||
          (this.numType == 3 && this.form.ajstatus == '二审')) &&
        (row.Attribute == '第三人' || row.Attribute == '原审第三人')
      ) {
        var nat = this.ershenArrtibute.filter(
          (item) => item.label == row.Attribute
        )
        row.order = nat[0].order
      } else {
        var nat = this.ArrtibuteOptions.filter(
          (item) => item.label == row.Attribute
        )
        row.order = nat[0].order
      }
      if(this.numType == 3&&this.form.ajstatus=='一审(行政诉讼)'){
        //  console.log("变化")
        if(row.Attribute=="请求人"||row.Attribute=="权利人"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.Attribute === '原告') {
              return { ...row, Attribute: '请求人', order: 101 }
            }
            if (row.Attribute === '被告') {
              return { ...row, Attribute: '权利人', order: 201 }
            }
            return row
          })
        }else if(row.Attribute=="原告"||row.Attribute=="被告"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.Attribute === '请求人') {
              return { ...row, Attribute: '原告', order: 100 }
            }
            if (row.Attribute === '权利人') {
              return { ...row, Attribute: '被告', order: 200 }
            }
            return row
          })
        }
      }
      // console.log('改变事件', this.form.tableData)
      this.form.tableData.sort((a, b) => {
        if (a.order === b.order) {
          return a.count - b.count
        } else {
          return a.order - b.order
        }
      })

      // this.getLitigants()
    },
    // 添加当事人
    addParty(row) {
      var isclient = null
      var isunit = null
      if (row != null) {
        this.addTableData = row.Attribute
        isclient = row.IsClient
        isunit = row.IsUnit
      }
      if (this.addTableData == null || this.addTableData == '') {
        return this.$message.error('请选择当事人身份！')
      }

  if(this.numType == 3&&this.form.ajstatus=='一审(行政诉讼)'){
        //  console.log("变化")
        if(this.addTableData=="请求人"||this.addTableData=="权利人"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.Attribute === '原告') {
              return { ...row, Attribute: '请求人', order: 101 }
            }
            if (row.Attribute === '被告') {
              return { ...row, Attribute: '权利人', order: 201 }
            }
            return row
          })
        }else if(this.addTableData=="原告"||this.addTableData=="被告"){
          this.form.tableData = this.form.tableData.map(row => {
            if (row.Attribute === '请求人') {
              return { ...row, Attribute: '原告', order: 100 }
            }
            if (row.Attribute === '权利人') {
              return { ...row, Attribute: '被告', order: 200 }
            }
            return row
          })
        }
      }
      // 当前已有的最大count
      let c = Math.max.apply(
        Math,
        this.form.tableData.map(function (f) {
          return f.count
        })
      )

      var td
      this.form.tableData.forEach((value, index, arr) => {
        if (this.addTableData == value.Attribute) {
          td = index
        }
      })

      var order
      this.ArrtibuteOptions.forEach((value) => {
        if (this.addTableData == value.value) {
          return (order = value.order)
        }
      })

      if (td === undefined) {
        if (this.form.tableData.length == 0) {
          this.form.tableData.push({
            // 表格
            IsUnit: isunit,
            Name: null,
            Idnumber:null,
            IsClient: isclient == null ? false : isclient,
            Attribute: this.addTableData,
            count: 0,
            order: order
          })
        } else {
          this.form.tableData.splice(td + 1, 0, {
            // 表格
            IsUnit: isunit,
            Name: null,
            Idnumber:null,
            IsClient: isclient == null ? false : isclient,
            Attribute: this.addTableData,
            count: c + 1,
            order: order
          })
        }
      } else {
        this.form.tableData.splice(td + 1, 0, {
          // 表格
          IsUnit: isunit,
          Name: null,
          Idnumber:null,
          IsClient: isclient == null ? false : isclient,
          Attribute: this.addTableData,
          count: c + 1,
          order: order
        })
      }
      console.log(this.addTableData,td)
     
    
      this.form.tableData.sort((a, b) => {
        return a.order - b.order
      })
  console.log(this.form.tableData)
      // this.getLitigants()
    },

    addParty09(row) {
      if (row != null) {
        this.addTableData = row.Attribute
      }
      if (this.addTableData == null || this.addTableData == '') {
        return this.$message.error('请选择当事人身份！')
      }

      var usct
      if (this.addTableData == '客户名称') {
        usct = true
      } else if (this.addTableData == '对方当事人') {
        usct = false
      }
      // 当前已有的最大count
      let c = Math.max.apply(
        Math,
        this.form.tableData.map(function (f) {
          return f.count
        })
      )

      var td
      this.form.tableData.forEach((value, index, arr) => {
        if (this.addTableData == value.Attribute) {
          td = index
        }
      })

      var order
      this.ArrtibuteOptions.forEach((value) => {
        if (this.addTableData == value.value) {
          return (order = value.order)
        }
      })

      if (td === undefined) {
        if (this.form.tableData.length == 0) {
          this.form.tableData.push({
            // 表格
            IsUnit: false,
            Name: null,
            Idnumber:null,
            IsClient: usct,
            Attribute: this.addTableData,
            count: 0,
            order: order
          })
        } else {
          this.form.tableData.splice(td + 1, 0, {
            // 表格
            IsUnit: false,
            Name: null,
            IsClient: usct,
            Idnumber:null,
            Attribute: this.addTableData,
            count: c + 1,
            order: order
          })
        }
      } else {
        this.form.tableData.splice(td + 1, 0, {
          // 表格
          IsUnit: false,
          Name: null,
          IsClient: usct,
          Idnumber:null,
          Attribute: this.addTableData,
          count: c + 1,
          order: order
        })
      }

      this.form.tableData.sort((a, b) => {
        return a.order - b.order
      })
      // this.getLitigants()
      // console.log('添加排序', this.form.tableData)
    },
    // 减少当事人
    reduceParty(c) {
      this.form.tableData.forEach((value, index, array) => {
        if (value.count != c) {
          this.newtableData.push(array[index])
        }
      })
      this.form.tableData = this.newtableData
      this.newtableData = []
      // this.getLitigants()
    },
    // 添加收费明细
    addCharge() {
      if (this.form.bcbdTable.length == 0) {
        this.form.bcbdTable.push({
          Name: null,
          Amount: null,
          PaymentDate: null,
          Remark: null,
          Status: null,
          count: 1
        })
      } else {
        let c = Math.max.apply(
          Math,
          this.form.bcbdTable.map(function (f) {
            return f.count
          })
        )
        this.form.bcbdTable.push({
          Name: null,
          Amount: null,
          PaymentDate: null,
          Remark: null,
          Status: null,
          count: c + 1
        })
      }
    },
    // 减少收费明细
    reduceCharge(c) {
      this.form.bcbdTable.forEach((value, index, array) => {
        if (value.count != c) {
          this.newbcbdTable.push(array[index])
        }
      })
      this.form.bcbdTable = this.newbcbdTable
      this.newbcbdTable = []
    },

    // 收费选择
    SF_Chargestatus(v) {
      // console.log('收费改变')
      if (v == '免费') {
        // 免费
        this.sfxz.fixed = false
        this.sfxz.riskFixed = false
        this.sfxz.riskRatio = false
        this.sfxz.detail = false
        this.sfxz.mfpz = true
        this.form.bcbdTable = []
      } else if (v == '固定收费') {
        // 固定收费
        this.sfxz.fixed = true
        this.sfxz.riskFixed = false
        this.sfxz.riskRatio = false
        this.sfxz.detail = true
        this.sfxz.mfpz = false
        if (this.form.bcbdTable.length == 0) {
          this.addCharge()
        }
      } else if (v == '风险收费') {
        // 风险收费
        this.sfxz.fixed = false
        this.sfxz.riskFixed = true
        this.sfxz.riskRatio = true
        this.sfxz.detail = true
        this.sfxz.mfpz = false
        if (this.form.bcbdTable.length == 0) {
          this.addCharge()
        }
      }
    },

    // 当事人copy
    copyParty(row) {
      // 获取最大count
      let c = Math.max.apply(
        Math,
        this.form.tableData.map(function (f) {
          return f.count
        })
      )

      var td
      this.form.tableData.forEach((value, index, arr) => {
        if (row.Attribute == value.Attribute) {
          td = index
        }
      })

      var order
      this.ArrtibuteOptions.forEach((value) => {
        if (this.addTableDat == value.value) {
          return (order = value.order)
        }
      })

      this.form.tableData.splice(td + 1, 0, {
        // 表格
        IsUnit: null,
        Name: null,
        IsClient: false,
        Attribute: row.Attribute,
        count: c + 1,
        order: order,
        Idnumber:null,
      })

      // this.form.tableData.push({
      //   // 表格
      //   IsUnit: null,
      //   Name: null,
      //   IsClient: false,
      //   Attribute: row.Attribute,
      //   count: c + 1
      // })
    },

    // 收费明细copy
    copyCharge(row) {
      let c = Math.max.apply(
        Math,
        this.form.bcbdTable.map(function (f) {
          return f.count
        })
      )
      this.form.bcbdTable.push({
        Name: row.Name,
        Amount: row.Amount,
        PaymentDate: row.PaymentDate,
        Remark: row.Remark,
        Status: row.Status,
        count: c + 1
      })
    },

    // 录入案件类型判断
    async inputType(ajs, cg) {
      // console.log(ajs)
      this.addTableData = null
      this.form.caseType = this.$route.query.status
      this.numType = Number(this.$route.query.num)
      if (this.form.caseType == '00000000-0000-0000-0001-000000000000') {
        this.titleType = '民事案件录入'
        this.Ajstatus = [
          { label: '一审', value: '一审' },
          { label: '二审', value: '二审' },
          { label: '再审', value: '再审' },
          { label: '破产申报', value: '破产申报' },
          { label: '破产申请', value: '破产申请' },
          { label: '再审听证', value: '再审听证' },
          { label:'强制清算',value:'强制清算'},
          { label: '执行', value: '执行' },
          { label: '审判监督', value: '审判监督' },
          { label: '公示催告', value: '公示催告' },
          { label: '督促', value: '督促' },
          { label: '选民资格案件(特别)', value: '选民资格案件(特别)' },
          {
            label: '宣告失踪、宣告死亡案件(特别)',
            value: '宣告失踪、宣告死亡案件(特别)'
          },
          {
            label: '认定公民无民事行为能力、限制行为能力案件(特别)',
            value: '认定公民无民事行为能力、限制行为能力案件(特别)'
          },
          { label: '认定财产无主案件(特别)', value: '认定财产无主案件(特别)' },
          {
            label: '制定遗产管理人案件(特别)',
            value: '制定遗产管理人案件(特别)'
          },
          { label: '确认调解协议案件(特别)', value: '确认调解协议案件(特别)' },
          { label: '实现担保物权案件(特别)', value: '实现担保物权案件(特别)' },
          { label: '申请撤销裁决', value: '申请撤销裁决' },
        ]
        this.form.sealForm.cities = [
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '律师出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '听证出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // console.log('ajs', this.form.sealForm.cities)
        if (ajs == '无' || ajs == null) {
          this.ArrtibuteOptions = []
         
        } else if (ajs == '一审') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '被告', label: '被告', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '二审') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 400 },
            { value: '原审原告', label: '原审原告', order: 500 },
            { value: '原审被告', label: '原审被告', order: 600 }
          ]
        } else if (ajs == '再审') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        }  else if (ajs == '申请撤销裁决') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '再审听证'||ajs=='强制清算') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '破产申报') {
          this.ArrtibuteOptions = [
            // { value: '申请人', label: '申请人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 },
            // { value: '第三人', label: '第三人', order: 300 },
            { value: '债权人', label: '债权人', order: 400 },
          ]
        } else if (ajs == '破产申请') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
          ]
        } else if (ajs == '执行') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被执行人', label: '被执行人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (ajs == '审判监督') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (ajs == '公示催告') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '支付人', label: '支付人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 }
          ]
        } else if (ajs == '督促') {
          this.ArrtibuteOptions = [
            { value: '债权人', label: '债权人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 }
          ]
        } else if (ajs == '选民资格案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '起诉人', label: '起诉人', order: 100 },
            { value: '选举委员会', label: '选举委员会', order: 200 },
            { value: '有关公民', label: '有关公民', order: 300 }
          ]
        } else if (ajs == '宣告失踪、宣告死亡案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        } else if (ajs == '认定公民无民事行为能力、限制行为能力案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '代理人', label: '代理人', order: 300 }
          ]
        } else if (ajs == '认定财产无主案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '原财产所有人', label: '原财产所有人', order: 200 },
            { value: '继承人', label: '继承人', order: 300 }
          ]
        } else if (ajs == '制定遗产管理人案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '遗产管理人', label: '遗产管理人', order: 300 }
          ]
        } else if (
          ajs == '确认调解协议案件(特别)' ||
          ajs == '实现担保物权案件(特别)'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0001-0001-0002-000000000000') {
        this.titleType = '刑事案件录入'
        this.Ajstatus = [
          { label: '侦查', value: '侦查' },
          { label: '审查起诉', value: '审查起诉' },
          { label: '法院审理(一审)', value: '法院审理(一审)' },
          { label: '被告人上诉(二审)', value: '被告人上诉(二审)' },
          { label: '检察机关抗诉(二审)', value: '检察机关抗诉(二审)' },
          { label: '刑事申诉', value: '刑事申诉' },
          { label: '再审', value: '再审' },
          { label: '自诉案件', value: '自诉案件' },
          { label: '刑事附带民事诉讼', value: '刑事附带民事诉讼' },
          // { label: '涉及单位犯罪', value: '涉及单位犯罪' },
          { label: '死刑复核程序', value: '死刑复核程序' },
          {
            label: '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序 ',
            value: '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序 '
          },
          {
            label: '依法不负刑事责任的精神病人的强制医疗程序',
            value: '依法不负刑事责任的精神病人的强制医疗程序'
          }
        ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
           
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师事务所函（侦查）', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师事务所函（检、审）', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '委托协议（辩护）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书（侦查）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书（检、审）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '取保候审申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书（刑事附带民事）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书（诉讼代表人）', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '调查取证申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '延期审理申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '解除强制措施申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '提请收集、调取证据申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '通知证人出庭申请书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '申请取保候审保证书', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '刑事案件事务所函', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
          
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     {
        //       name: '委托协议（辩护）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '授权委托书（侦查）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '授权委托书（检、审）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '取保候审申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)CRE
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '授权委托书（刑事附带民事）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '授权委托书（诉讼代表人）', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '调查取证申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '延期审理申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '解除强制措施申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '提请收集、调取证据申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '通知证人出庭申请书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '申请取保候审保证书', // 模板名
        //       type: 1, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '法律意见书审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['law_seal'] // 用章类型
        //     },
        //     {
        //       name: '单独出具律师函审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['legal_letter_seal'] // 用章类型
        //     },
        //     {
        //       name: '案件审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '律师事务所函（侦查）', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     },
        //     {
        //       name: '律师事务所函（检、审）', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // } else
         if (ajs == '侦查' || ajs == '审查起诉') {
          this.ArrtibuteOptions = [
            { value: '犯罪嫌疑人', label: '犯罪嫌疑人', order: 100 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '法院审理(一审)') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            // { value: '控诉人', label: '控诉人', order: 200 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '被告人上诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '检察机关', label: '检察机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '检察机关抗诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '抗诉人', label: '抗诉人', order: 100 },
            // { value: '被抗诉人', label: '被抗诉人', order: 200 },
            { value: '原审被告人', label: '原审被告人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '刑事申诉') {
          this.ArrtibuteOptions = [
            { value: '申诉人', label: '申诉人', order: 100 }
          ]
        } else if (ajs == '再审') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (ajs == '自诉案件') {
          this.ArrtibuteOptions = [
            { value: '自诉人', label: '自诉人', order: 100 },
            { value: '被告人', label: '被告人', order: 200 }
          ]
        } else if (ajs == '刑事附带民事诉讼') {
          this.ArrtibuteOptions = [
            {
              value: '刑事附带民事诉讼原告',
              label: '刑事附带民事诉讼原告',
              order: 100
            },
            {
              value: '刑事附带民事诉讼被告',
              label: '刑事附带民事诉讼被告',
              order: 200
            }
          ]
        } else if (ajs == '涉及单位犯罪') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            { value: '控诉人', label: '控诉人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (ajs == '死刑复核程序') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 }
          ]
        } else if (
          ajs == '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          ajs == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0002-0002-0003-000000000000') {
        this.titleType = '行政案件录入'
        this.Ajstatus = [
          { label: '一审(行政诉讼)', value: '一审(行政诉讼)' },
          { label: '二审(行政诉讼)', value: '二审(行政诉讼)' },
          { label: '申请再审(行政诉讼)', value: '申请再审(行政诉讼)' },
          { label: '执行阶段(行政诉讼)', value: '执行阶段(行政诉讼)' },
          { label:'行政裁决',value:'行政裁决'},
          { label: '行政复议', value: '行政复议' },
          { label: '行政处罚', value: '行政处罚' },
          { label: '行政许可', value: '行政许可' },
          { label: '行政强制', value: '行政强制' },
          { label: '政府信息公开', value: '政府信息公开' }
        ]

        this.form.sealForm.cities = [
           
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '行政复议出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })

        if (ajs == '无' || ajs == null) {
          this.ArrtibuteOptions = []
        } else if (ajs == '一审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '请求人', label: '请求人', order: 101 },
            { value: '被告', label: '被告', order: 200 },
            { value: '权利人', label: '权利人', order: 201 },
            { value: '第三人', label: '第三人', order: 300 },
          ]
        } else if (ajs == '二审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 300 },
            { value: '原审原告', label: '原审原告', order: 300 },
            { value: '原审被告', label: '原审被告', order: 300 }
          ]
        } else if (ajs == '申请再审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '原审第三人', label: '原审第三人', order: 300 }
          ]
        } else if (ajs == '行政裁决') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        }else if (ajs == '行政复议') {
          this.ArrtibuteOptions = [
            { value: '复议申请人', label: '复议申请人', order: 100 },
            { value: '复议被申请人', label: '复议被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '执行阶段(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被申请执行人', label: '被申请执行人', order: 200 },
            {
              value: '执行异议中的利害关系人',
              label: '执行异议中的利害关系人',
              order: 300
            },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (ajs == '行政处罚') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 300
            }
          ]
        } else if (ajs == '行政许可') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被许可人', label: '被许可人', order: 200 },
            {
              value: '行政主体',
              label: '行政主体',
              order: 300
            },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 400
            }
          ]
        } else if (ajs == '行政强制') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '其他人员',
              label: '其他人员',
              order: 300
            }
          ]
        } else if (ajs == '政府信息公开') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请机关', label: '被申请机关', order: 200 },
            {
              value: '第三方',
              label: '第三方',
              order: 300
            }
          ]
        }
      } else if (this.form.caseType == '00000000-0003-0003-0004-000000000000') {
        this.titleType = '执行案件录入'
        this.ArrtibuteOptions = [
          { value: '申请执行人', label: '申请执行人', order: 100 },
          { value: '被执行人', label: '被执行人', order: 200 },
          { value: '执行异议人', label: '执行异议人', order: 300 },
          { value: '案外人', label: '案外人', order: 400 },
          { value: '复议申请人', label: '复议申请人', order: 500 },
          
        ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        if (ajs == null || ajs == '' || ajs == '受理') {
          // if (this.form.sealForm.checkedCities.length > 0) {
          //   this.form.sealForm.checkedCities = []
          // }
          // this.form.sealForm.cities = [
          //   {
          //     name: '授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '法律意见书审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['law_seal'] // 用章类型
          //   },
          //   {
          //     name: '单独出具律师函审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['legal_letter_seal'] // 用章类型
          //   },
          //   {
          //     name: '案件审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '律师出庭函', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   }
          // ]
          // this.form.sealForm.cities.forEach((value) => {
          //   this.form.sealForm.checkedCities.push(value.name)
          // })
        }
      } else if (this.form.caseType == '00000000-0004-0004-0005-000000000000') {
        this.titleType = '劳动仲裁录入'
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 }
          // { value: '第三人', label: '第三人', order: 300 }
        ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        if (ajs == null || ajs == '' || ajs == '受理') {
          // if (this.form.sealForm.checkedCities.length > 0) {
          //   this.form.sealForm.checkedCities = []
          // }
          // this.form.sealForm.cities = [
          //   {
          //     name: '授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '法律意见书审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['law_seal'] // 用章类型
          //   },
          //   {
          //     name: '单独出具律师函审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['legal_letter_seal'] // 用章类型
          //   },
          //   {
          //     name: '案件审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '律师出庭函', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   }
          // ]
          // this.form.sealForm.cities.forEach((value) => {
          //   this.form.sealForm.checkedCities.push(value.name)
          // })
        }
      } else if (this.form.caseType == '00000000-0005-0005-0006-000000000000') {
        this.titleType = '商事案件录入'
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 }
          // { value: '第三人', label: '第三人', order: 300 }
        ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '律师出庭函', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(单位)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
            {
              name: '执行授权委托书(个人)', // 模板名
              type: 1, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            },
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        if (ajs == null || ajs == '' || ajs == '受理') {
          // if (this.form.sealForm.checkedCities.length > 0) {
          //   this.form.sealForm.checkedCities = []
          // }
          // this.form.sealForm.cities = [
          //   {
          //     name: '授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(单位)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '执行授权委托书(个人)', // 模板名
          //     type: 1, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '法律意见书审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['law_seal'] // 用章类型
          //   },
          //   {
          //     name: '单独出具律师函审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['legal_letter_seal'] // 用章类型
          //   },
          //   {
          //     name: '案件审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   },
          //   {
          //     name: '律师出庭函', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   }
          // ]
          // this.form.sealForm.cities.forEach((value) => {
          //   this.form.sealForm.checkedCities.push(value.name)
          // })
        }
      } else if (this.form.caseType == '00000000-0006-0006-0007-000000000000') {
        this.titleType = '一般非诉项目录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        if (ajs == null || ajs == '' || ajs == '受理') {
          // this.Ajstatus = [
          //   { label: '受理', value: '受理' },
          //   { label: '未受理', value: '未受理' }
          // ]
          // if (this.form.sealForm.checkedCities.length > 0) {
          //   this.form.sealForm.checkedCities = []
          // }
          // this.form.sealForm.cities = [
          //   {
          //     name: '法律意见书审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['law_seal'] // 用章类型
          //   },
          //   {
          //     name: '单独出具律师函审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['legal_letter_seal'] // 用章类型
          //   },
          //   {
          //     name: '案件审批单', // 模板名
          //     type: 2, // 类型(1:导出，2:打印)
          //     stype: ['official_seal'] // 用章类型
          //   }
          // ]
          // this.form.sealForm.cities.forEach((value) => {
          //   this.form.sealForm.checkedCities.push(value.name)
          // })
        }
      } else if (this.form.caseType == '00000000-0007-0007-0008-000000000000') {
        this.titleType = '单独出具法律意见审批书录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal','official_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   this.Ajstatus = [
        //     { label: '受理', value: '受理' },
        //     { label: '未受理', value: '未受理' }
        //   ]
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     {
        //       name: '法律意见书审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['law_seal'] // 用章类型
        //     },
        //     {
        //       name: '单独出具律师函审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['legal_letter_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }

        // this.Seal = this.SealChange
      } else if (this.form.caseType == '00000000-0013-0013-0014-000000000000') {
        this.titleType = '证券类业务录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   this.Ajstatus = [
        //     { label: '受理', value: '受理' },
        //     { label: '未受理', value: '未受理' }
        //   ]
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     {
        //       name: '法律意见书审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['law_seal'] // 用章类型
        //     },
        //     {
        //       name: '单独出具律师函审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['legal_letter_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }

        // this.Seal = this.SealChange
      } else if (this.form.caseType == '00000000-0008-0008-0009-000000000000') {
        this.Ajstatus = [
          { label: '受理', value: '受理' },
          { label: '未受理', value: '未受理' }
        ]
        this.titleType = '单独出具律师函录入'
        this.ArrtibuteOptions = [
          { value: '客户名称', label: '客户名称', order: 100 },
          { value: '对方当事人', label: '对方当事人', order: 200 }
        ]
        this.form.tableData = [
          {
            // 表格
            IsUnit: false,
            Name: null,
            IsClient: true,
            Attribute: '客户名称',
            count: 0,
            order: 100,
            Idnumber:null,
          },
          {
            // 表格
            IsUnit: false,
            Name: null,
            IsClient: false,
            Attribute: '对方当事人',
            count: 1,
            order: 200,
            Idnumber:null,
          }
        ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            {
              name: '法律意见书审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)

              stype: ['law_seal'] // 用章类型
            },
            {
              name: '单独出具律师函审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['legal_letter_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   this.Ajstatus = [
        //     { label: '受理', value: '受理' },
        //     { label: '未受理', value: '未受理' }
        //   ]
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     {
        //       name: '法律意见书审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)

        //       stype: ['law_seal'] // 用章类型
        //     },
        //     {
        //       name: '单独出具律师函审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['legal_letter_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }

        // this.Seal = this.SealChange
      } else if (this.form.caseType == '00000000-0009-0009-0010-000000000000') {
        this.titleType = '其他与法律服务有关的招投标项目栏录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
        if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            // {
            //   name: '法律意见书审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['law_seal'] // 用章类型
            // },
            // {
            //   name: '单独出具律师函审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['legal_letter_seal'] // 用章类型
            // },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     // {
        //     //   name: '法律意见书审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['law_seal'] // 用章类型
        //     // },
        //     // {
        //     //   name: '单独出具律师函审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['legal_letter_seal'] // 用章类型
        //     // },
        //     {
        //       name: '案件审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }
      } else if (this.form.caseType == '00000000-0010-0010-0011-000000000000') {
        this.titleType = '专项服务合同录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            // {
            //   name: '法律意见书审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['law_seal'] // 用章类型
            // },
            // {
            //   name: '单独出具律师函审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['legal_letter_seal'] // 用章类型
            // },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   this.Ajstatus = [
        //     { label: '受理', value: '受理' },
        //     { label: '未受理', value: '未受理' }
        //   ]
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     // {
        //     //   name: '法律意见书审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['law_seal'] // 用章类型
        //     // },
        //     // {
        //     //   name: '单独出具律师函审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['legal_letter_seal'] // 用章类型
        //     // },
        //     {
        //       name: '案件审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }
      } else if (this.form.caseType == '00000000-0014-0014-0015-000000000000') {
        this.titleType = '律师见证录入'
        this.Ajstatus = [
            { label: '受理', value: '受理' },
            { label: '未受理', value: '未受理' }
          ]
          if (this.form.sealForm.checkedCities.length > 0) {
            this.form.sealForm.checkedCities = []
          }
          this.form.sealForm.cities = [
            // {
            //   name: '法律意见书审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['law_seal'] // 用章类型
            // },
            // {
            //   name: '单独出具律师函审批单', // 模板名
            //   type: 2, // 类型(1:导出，2:打印)
            //   stype: ['legal_letter_seal'] // 用章类型
            // },
            {
              name: '案件审批单', // 模板名
              type: 2, // 类型(1:导出，2:打印)
              stype: ['official_seal'] // 用章类型
            }
          ]
          this.form.sealForm.cities.forEach((value) => {
            this.form.sealForm.checkedCities.push(value.name)
          })
        // if (ajs == null || ajs == '' || ajs == '受理') {
        //   this.Ajstatus = [
        //     { label: '受理', value: '受理' },
        //     { label: '未受理', value: '未受理' }
        //   ]
        //   if (this.form.sealForm.checkedCities.length > 0) {
        //     this.form.sealForm.checkedCities = []
        //   }
        //   this.form.sealForm.cities = [
        //     // {
        //     //   name: '法律意见书审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['law_seal'] // 用章类型
        //     // },
        //     // {
        //     //   name: '单独出具律师函审批单', // 模板名
        //     //   type: 2, // 类型(1:导出，2:打印)
        //     //   stype: ['legal_letter_seal'] // 用章类型
        //     // },
        //     {
        //       name: '案件审批单', // 模板名
        //       type: 2, // 类型(1:导出，2:打印)
        //       stype: ['official_seal'] // 用章类型
        //     }
        //   ]
        //   this.form.sealForm.cities.forEach((value) => {
        //     this.form.sealForm.checkedCities.push(value.name)
        //   })
        // }
      } else {
        this.titleType = '未知项目类型'
      }

      // if (cg != 'change') {
      //   if (this.form.caseType == '00000000-0001-0001-0002-000000000000') {
      //   } else if (
      //     this.form.caseType == '00000000-0000-0000-0001-000000000000' &&
      //     this.form.ajstatus == '二审'
      //   ) {
      //   } else if (
      //     this.form.caseType == '00000000-0002-0002-0003-000000000000' &&
      //     this.form.ajstatus == '二审'
      //   ) {
      //   } else if (
      //     this.form.caseType == '00000000-0008-0008-0009-000000000000'
      //   ) {
      //   } else {
      //     this.form.tableData = []
      //     // console.log('自动添加当事人', this.ArrtibuteOptions)
      //     this.ArrtibuteOptions.forEach((v) => {
      //       // 当前已有的最大count
      //       let c = Math.max.apply(
      //         Math,
      //         this.form.tableData.map(function (f) {
      //           return f.count
      //         })
      //       )

      //       var td
      //       this.form.tableData.forEach((value, index, arr) => {
      //         if (v.value == value.Attribute) {
      //           td = index
      //         }
      //       })

      //       var order
      //       this.ArrtibuteOptions.forEach((value) => {
      //         if (v.value == value.value) {
      //           return (order = value.order)
      //         }
      //       })

      //       if (td === undefined) {
      //         if (this.form.tableData.length == 0) {
      //           this.form.tableData.push({
      //             // 表格
      //             IsUnit: null,
      //             Name: null,
      //             IsClient: false,
      //             Attribute: v.value,
      //             count: 0,
      //             order: order
      //           })
      //         } else {
      //           this.form.tableData.splice(td + 1, 0, {
      //             // 表格
      //             IsUnit: null,
      //             Name: null,
      //             IsClient: false,
      //             Attribute: v.value,
      //             count: c + 1,
      //             order: order
      //           })
      //         }
      //       } else {
      //         this.form.tableData.splice(td + 1, 0, {
      //           // 表格
      //           IsUnit: null,
      //           Name: null,
      //           IsClient: false,
      //           Attribute: v.value,
      //           count: c + 1,
      //           order: order
      //         })
      //       }

      //       this.form.tableData.sort((a, b) => {
      //         return a.order - b.order
      //       })
      //     })
      //   }
      // }
      this.form.tableData = []
      // console.log('自动添加当事人', this.ArrtibuteOptions)
      this.ArrtibuteOptions.forEach((v) => {
        // 当前已有的最大count
        let c = Math.max.apply(
          Math,
          this.form.tableData.map(function (f) {
            return f.count
          })
        )
        
        var td
        this.form.tableData.forEach((value, index, arr) => {
          if (v.value == value.Attribute) {
            td = index
          }
        })

        var order
        this.ArrtibuteOptions.forEach((value) => {
          if (v.value == value.value) {
            return (order = value.order)
          }
        })
      
        if (td === undefined) {
          if (this.form.tableData.length == 0) {
            this.form.tableData.push({
              // 表格
              IsUnit: null,
              Name: null,
              IsClient: false,
              Attribute: v.value,
              count: 0,
              order: order,
              Idnumber:null,
            })
          } else {
            this.form.tableData.splice(td + 1, 0, {
              // 表格
              IsUnit: null,
              Name: null,
              IsClient: false,
              Attribute: v.value,
              count: c + 1,
              order: order,
              Idnumber:null,
            })
          }
        } else {
          this.form.tableData.splice(td + 1, 0, {
            // 表格
            IsUnit: null,
            Name: null,
            IsClient: false,
            Attribute: v.value,
            count: c + 1,
            order: order,
            Idnumber:null,
          })
        }

        this.form.tableData.sort((a, b) => {
          return a.order - b.order
        })
      })
      if(this.form.caseType == '00000000-0002-0002-0003-000000000000'&&ajs == '一审(行政诉讼)'){
        //去掉101和201
        this.form.tableData = this.form.tableData.filter(item => item.order !== 101 && item.order !== 201)
      }
      // console.log( this.form.tableData)
      if (this.form.caseType == '00000000-0008-0008-0009-000000000000'){
        this.form.tableData = [
          {
            // 表格
            IsUnit: false,
            Name: null,
            IsClient: true,
            Attribute: '客户名称',
            count: 0,
            order: 100,
            Idnumber:null,
          },
          {
            // 表格
            IsUnit: false,
            Name: null,
            IsClient: false,
            Attribute: '对方当事人',
            count: 1,
            order: 200,
            Idnumber:null,
          }
        ]
      }
      // this.getLitigants()
      // console.log("变化",this.form.sealForm.cities)
    },

    repeatType() {
      this.form.caseType = this.$route.query.status
      if (this.form.caseType == '00000000-0000-0000-0001-000000000000') {
        if (this.form.ajstatus == '一审') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '被告', label: '被告', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (this.form.ajstatus == '二审') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 400 },
            { value: '原审原告', label: '原审原告', order: 500 },
            { value: '原审被告', label: '原审被告', order: 600 }
          ]
        } else if (this.form.ajstatus == '再审'||this.form.ajstatus =='申请撤销裁决') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus =='强制清算') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (this.form.ajstatus == '破产申报') {
          this.ArrtibuteOptions = [
            // { value: '申请人', label: '申请人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 },
            // { value: '第三人', label: '第三人', order: 300 },
            { value: '债权人', label: '债权人', order: 400 },
          ]
        } else if (this.form.ajstatus == '破产申请') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }else if (this.form.ajstatus == '执行') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被执行人', label: '被执行人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (this.form.ajstatus == '审判监督') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (this.form.ajstatus == '公示催告') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '支付人', label: '支付人', order: 200 },
            { value: '利害关系人', label: '利害关系人', order: 300 }
          ]
        } else if (this.form.ajstatus == '督促') {
          this.ArrtibuteOptions = [
            { value: '债权人', label: '债权人', order: 100 },
            { value: '债务人', label: '债务人', order: 200 }
          ]
        } else if (this.form.ajstatus == '选民资格案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '起诉人', label: '起诉人', order: 100 },
            { value: '选举委员会', label: '选举委员会', order: 200 },
            { value: '有关公民', label: '有关公民', order: 300 }
          ]
        } else if (this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        } else if (
          this.form.ajstatus == '认定公民无民事行为能力、限制行为能力案件(特别)'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '代理人', label: '代理人', order: 300 }
          ]
        } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '原财产所有人', label: '原财产所有人', order: 200 },
            { value: '继承人', label: '继承人', order: 300 }
          ]
        } else if (this.form.ajstatus == '制定遗产管理人案件(特别)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '遗产管理人', label: '遗产管理人', order: 300 }
          ]
        } else if (
          this.form.ajstatus == '确认调解协议案件(特别)' ||
          this.form.ajstatus == '实现担保物权案件(特别)'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0001-0001-0002-000000000000') {
        if (
          this.form.ajstatus == '侦查' ||
          this.form.ajstatus == '审查起诉'
        ) {
          this.ArrtibuteOptions = [
            { value: '犯罪嫌疑人', label: '犯罪嫌疑人', order: 100 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (this.form.ajstatus == '法院审理(一审)') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            // { value: '控诉人', label: '控诉人', order: 200 },
            { value: '公诉机关', label: '公诉机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (this.form.ajstatus == '被告人上诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '检察机关', label: '检察机关', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
          this.ArrtibuteOptions = [
            { value: '抗诉人', label: '抗诉人', order: 100 },
            // { value: '被抗诉人', label: '被抗诉人', order: 200 },
            { value: '原审被告人', label: '原审被告人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (this.form.ajstatus == '刑事申诉') {
          this.ArrtibuteOptions = [
            { value: '申诉人', label: '申诉人', order: 100 }
          ]
        } else if (this.form.ajstatus == '再审') {
          this.ArrtibuteOptions = [
            { value: '再审申请人', label: '再审申请人', order: 100 },
            { value: '再审被申请人', label: '再审被申请人', order: 200 }
          ]
        } else if (this.form.ajstatus == '自诉案件') {
          this.ArrtibuteOptions = [
            { value: '自诉人', label: '自诉人', order: 100 },
            { value: '被告人', label: '被告人', order: 200 }
          ]
        } else if (this.form.ajstatus == '刑事附带民事诉讼') {
          this.ArrtibuteOptions = [
            {
              value: '刑事附带民事诉讼原告',
              label: '刑事附带民事诉讼原告',
              order: 100
            },
            {
              value: '刑事附带民事诉讼被告',
              label: '刑事附带民事诉讼被告',
              order: 200
            }
          ]
        } else if (this.form.ajstatus == '涉及单位犯罪') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 },
            { value: '控诉人', label: '控诉人', order: 200 },
            { value: '被害人', label: '被害人', order: 300 }
          ]
        } else if (this.form.ajstatus == '死刑复核程序') {
          this.ArrtibuteOptions = [
            { value: '被告人', label: '被告人', order: 100 }
          ]
        } else if (
          this.form.ajstatus ==
            '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
          this.form.ajstatus == '依法不负刑事责任的精神病人的强制医疗程序'
        ) {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 }
          ]
        }
      } else if (this.form.caseType == '00000000-0002-0002-0003-000000000000') {
        var ajs=this.form.ajstatus
        if (ajs == '一审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '原告', label: '原告', order: 100 },
            { value: '请求人', label: '请求人', order: 101 },
            { value: '被告', label: '被告', order: 200 },
            { value: '权利人', label: '权利人', order: 201 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '二审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '上诉人', label: '上诉人', order: 100 },
            { value: '被上诉人', label: '被上诉人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 },
            { value: '原审第三人', label: '原审第三人', order: 300 },
            { value: '原审原告', label: '原审原告', order: 300 },
            { value: '原审被告', label: '原审被告', order: 300 }
          ]
        } else if (ajs == '申请再审(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '原审第三人', label: '原审第三人', order: 300 }
          ]
        } else if (ajs == '行政裁决') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请人', label: '被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '行政复议') {
          this.ArrtibuteOptions = [
            { value: '复议申请人', label: '复议申请人', order: 100 },
            { value: '复议被申请人', label: '复议被申请人', order: 200 },
            { value: '第三人', label: '第三人', order: 300 }
          ]
        } else if (ajs == '执行阶段(行政诉讼)') {
          this.ArrtibuteOptions = [
            { value: '申请执行人', label: '申请执行人', order: 100 },
            { value: '被申请执行人', label: '被申请执行人', order: 200 },
            {
              value: '执行异议中的利害关系人',
              label: '执行异议中的利害关系人',
              order: 300
            },
            { value: '案外人', label: '案外人', order: 400 }
          ]
        } else if (ajs == '行政处罚') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 300
            }
          ]
        } else if (ajs == '行政许可') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被许可人', label: '被许可人', order: 200 },
            {
              value: '行政主体',
              label: '行政主体',
              order: 300
            },
            {
              value: '利害关系人',
              label: '利害关系人',
              order: 400
            }
          ]
        } else if (ajs == '行政强制') {
          this.ArrtibuteOptions = [
            { value: '当事人', label: '当事人', order: 100 },
            { value: '行政主体', label: '行政主体', order: 200 },
            {
              value: '其他人员',
              label: '其他人员',
              order: 300
            }
          ]
        } else if (ajs == '政府信息公开') {
          this.ArrtibuteOptions = [
            { value: '申请人', label: '申请人', order: 100 },
            { value: '被申请机关', label: '被申请机关', order: 200 },
            {
              value: '第三方',
              label: '第三方',
              order: 300
            }
          ]
        }
      } else if (this.form.caseType == '00000000-0003-0003-0004-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请执行人', label: '申请执行人', order: 100 },
          { value: '被执行人', label: '被执行人', order: 200 },
          { value: '执行异议人', label: '执行异议人', order: 300 },
          { value: '案外人', label: '案外人', order: 400 },
          { value: '复议申请人', label: '复议申请人', order: 500 },
        ]
      } else if (this.form.caseType == '00000000-0004-0004-0005-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 }
          // { value: '第三人', label: '第三人', order: 300 }
        ]
      } else if (this.form.caseType == '00000000-0005-0005-0006-000000000000') {
        this.ArrtibuteOptions = [
          { value: '申请人', label: '申请人', order: 100 },
          { value: '被申请人', label: '被申请人', order: 200 }
          // { value: '第三人', label: '第三人', order: 300 }
        ]
      } else if (this.form.caseType == '00000000-0008-0008-0009-000000000000') {
        this.ArrtibuteOptions = [
          { value: '客户名称', label: '客户名称', order: 100 },
          { value: '对方当事人', label: '对方当事人', order: 200 }
        ]
      }
    },
    // 确认提交
    inputCase(formref) {
      this.dianji = true
      this.loading = true
      if(this.numType==9){
          this.form.tableData.forEach((el,index)=>{
            if(el.Attribute=='客户名称'){
              el.IsClient=true
            }else{
              el.IsClient=false
            }
            el.IsUnit=true
          })
        }
      
      // console.log('form.caseLeaders', this.form.caseLeaders)
     
      var labelArr = []
      var allLawyer = this.form.leadLawyer.concat(
        this.form.coCounsel == '' || null ? [] : this.form.coCounsel
      )
      allLawyer.forEach((item) => {
        this.Lawyer.forEach((value) => {
          if (item == value.id && value.practice) {
            labelArr.push(item.practice)
          }
        })
      })
      if (labelArr.length == allLawyer.length) {
        this.$message.error('实习律师不能单独录案件')
        this.loading = false
        this.dianji = false
        return
      }
      if (
        this.numType != 7 &&
        this.numType != 8 &&
        this.numType != 14 &&
        this.numType != 9 &&
        this.numType != 11 &&
        this.numType != 15 &&
        this.form.ajstatus == '无'
      ) {
        this.loading = false
        this.dianji = false
        return this.$message.error(
          '当前案件类型不允许案卷状态为‘无’！请重新选择'
        )
      }

      this.form.biddingSchemes = this.FileList1.map((v) => {
        return v.uid
      })
      this.form.ordinaryFiles = this.FileList2.map((v) => {
        return v.uid
      })

      this.form.sealForm.sealFile = this.FileList.map((v) => {
        return v.uid
      })
      this.form.freeFiles = this.FileList3.map((v) => {
        return v.uid
      })
      this.form.chujuFiles = this.FileList4.map((v) => {
        return v.uid
      })
      // if (this.form.biddingSchemes.length == 0) {
      //   return this.$message.error('至少要上传一个合同附件！')
      // }

      // 验证通过-- > 表单验证
      this.$refs[formref].validate((valid) => {
        if (valid) {
          this.$refs['sealForm'].validate(async (valid) => {
            if (valid) {
              // 案件冲突校验
              var bitian = true
              var arrbt = this.form.tableData
             
              if (
                this.numType == 1 ||
                this.numType == 2 ||
                this.numType == 3 ||
                this.numType == 4 ||
                this.numType == 5 ||
                this.numType == 6
              ) {
                if (this.form.tableData.length == 0) {
                  this.loading = false
                  this.dianji = false
                  return this.$message.error('请录入案件当事人!')
                }
                var clientBool = false
                arrbt.forEach((v) => {
                  if (v.IsClient == true) {
                    clientBool = true
                    return
                  }
                })
               
                if (!clientBool) {
                  this.loading = false
                  this.dianji = false
                  return this.$message.error('请选择代理方！')
                }
                // console.log('this.form.ajstatus', this.form.ajstatus)

                if (this.numType == 1) {//民事案件破产申报申请人非必填，其他的还是必填
                  if (this.form.ajstatus == '一审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '原告') {
                          bitian = false
                          this.$message.error('请完善原告信息！')
                          break
                        } else if (arrbt[i].Attribute == '被告') {
                          bitian = false
                          this.$message.error('请完善被告信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '二审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被上诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '上诉人') {
                          bitian = false
                          this.$message.error('请完善上诉人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被上诉人') {
                          bitian = false
                          this.$message.error('请完善被上诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审'||this.form.ajstatus == '申请撤销裁决') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审听证'||this.form.ajstatus =='强制清算') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                      
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '破产申报') {
                    
                    // if (
                    //     !this.form.tableData.some(
                    //       (item) => item.Attribute == '申请人'
                    //     )
                    //   ) {
                    //     this.loading = false
                    //     this.dianji = false
                    //     return this.$message.error('请添加申请人！')
                    //   }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '债务人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债务人！')
                    }
                    
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        // if (arrbt[i].Attribute == '申请人') {
                        //   this.$message.error('请完善申请人信息！')
                        //   console.log('申请人')
                        //   bitian = false
                        //   break
                        // } else
                        if (arrbt[i].Attribute == '债务人') {
                          this.$message.error('请完善债务人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  }  else if (this.form.ajstatus == '破产申请') {
                    
                    if (
                        !this.form.tableData.some(
                          (item) => item.Attribute == '申请人'
                        )
                      ) {
                        this.loading = false
                        this.dianji = false
                        return this.$message.error('请添加申请人！')
                      }
                   
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  }else if (this.form.ajstatus == '执行') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请执行人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被执行人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请执行人') {
                          bitian = false
                          this.$message.error('请完善申请执行人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被执行人') {
                          bitian = false
                          this.$message.error('请完善被执行人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '审判监督(再审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '再审申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '再审被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '再审申请人') {
                          bitian = false
                          this.$message.error('请完善再审申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '再审被申请人') {
                          bitian = false
                          this.$message.error('请完善再审被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '公示催告') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '支付人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加支付人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '支付人') {
                          bitian = false
                          this.$message.error('请完善支付人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '督促') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '债权人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债权人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '债务人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加债务人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '债权人') {
                          bitian = false
                          this.$message.error('请完善债权人信息！')
                          break
                        } else if (arrbt[i].Attribute == '债务人') {
                          bitian = false
                          this.$message.error('请完善债务人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '选民资格案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '起诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加起诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '选举委员会'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加选举委员会！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '起诉人') {
                          bitian = false
                          this.$message.error('请完善起诉人信息！')
                          break
                        } else if (arrbt[i].Attribute == '选举委员会') {
                          bitian = false
                          this.$message.error('请完善选举委员会信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus == '宣告失踪、宣告死亡案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus ==
                    '认定公民无民事行为能力、限制行为能力案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '认定财产无主案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '原财产所有人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原财产所有人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '原财产所有人') {
                          bitian = false
                          this.$message.error('请完善原财产所有人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '制定遗产管理人案件(特别)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus == '确认调解协议案件(特别)' ||
                    this.form.ajstatus == '实现担保物权案件(特别)'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 2) {
                  if (
                    this.form.ajstatus == '侦查' ||
                    this.form.ajstatus == '审查起诉'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '犯罪嫌疑人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加犯罪嫌疑人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '公诉机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加公诉机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '犯罪嫌疑人') {
                          bitian = false
                          this.$message.error('请完善犯罪嫌疑人信息！')
                          break
                        } else if (arrbt[i].Attribute == '公诉机关') {
                          bitian = false
                          this.$message.error('请完善公诉机关信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '法院审理(一审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    if (
                      !this.form.tableData.some(
                        // (item) => item.Attribute == '控诉人'
                        (item) => item.Attribute == '公诉机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      // return this.$message.error('请添加控诉人！')
                      return this.$message.error('请添加公诉机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        } 
                        else if (arrbt[i].Attribute == '公诉机关') {
                          bitian = false
                          this.$message.error('请完善公诉机关信息！')
                          break
                        }
                        // else if (arrbt[i].Attribute == '控诉人') {
                        //   bitian = false
                        //   this.$message.error('请完善控诉人信息！')
                        //   break
                        // }
                      }
                    }
                  } else if (this.form.ajstatus == '被告人上诉(二审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '检察机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加检察机关！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '上诉人') {
                          bitian = false
                          this.$message.error('请完善上诉人信息！')
                          break
                        } else if (arrbt[i].Attribute == '检察机关') {
                          bitian = false
                          this.$message.error('请完善检察机关信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '检察机关抗诉(二审)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '抗诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加抗诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        // (item) => item.Attribute == '被抗诉人'
                        (item) => item.Attribute == '原审被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      // return this.$message.error('请添加被抗诉人！')
                      return this.$message.error('请添加原审被告人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '抗诉人') {
                          bitian = false
                          this.$message.error('请完善抗诉人信息！')
                          break
                        }
                        //  else if (arrbt[i].Attribute == '被抗诉人') {
                        //   bitian = false
                        //   this.$message.error('请完善被抗诉人信息！')
                        //   break
                        // }
                        else if (arrbt[i].Attribute == '原审被告人') {
                          bitian = false
                          this.$message.error('请完善原审被告人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '刑事申诉') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申诉人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申诉人') {
                          bitian = false
                          this.$message.error('请完善申诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '再审') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '再审申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '再审被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加再审被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '再审申请人') {
                          bitian = false
                          this.$message.error('请完善再审申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '再审被申请人') {
                          bitian = false
                          this.$message.error('请完善再审被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '自诉案件') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '自诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加自诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '自诉人') {
                          bitian = false
                          this.$message.error('请完善自诉人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '刑事附带民事诉讼') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '刑事附带民事诉讼原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加刑事附带民事诉讼原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '刑事附带民事诉讼被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加刑事附带民事诉讼被告！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (
                          arrbt[i].Attribute == '自刑事附带民事诉讼原告诉人'
                        ) {
                          bitian = false
                          this.$message.error(
                            '请完善刑事附带民事诉讼原告信息！'
                          )
                          break
                        } else if (
                          arrbt[i].Attribute == '刑事附带民事诉讼被告'
                        ) {
                          bitian = false
                          this.$message.error(
                            '请完善刑事附带民事诉讼被告信息！'
                          )
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '涉及单位犯罪') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '控诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加控诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        } else if (arrbt[i].Attribute == '控诉人') {
                          bitian = false
                          this.$message.error('请完善控诉人信息！')
                          break
                        }
                      }
                    }
                  } else if (
                    this.form.ajstatus ==
                      '犯罪嫌疑人、被告人逃匿、死亡案件违法所得的没收程序' ||
                    this.form.ajstatus ==
                      '依法不负刑事责任的精神病人的强制医疗程序'
                  ) {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          bitian = false
                          this.$message.error('请完善申请人信息！')
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          bitian = false
                          this.$message.error('请完善被申请人信息！')
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '死刑复核程序') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '被告人') {
                          bitian = false
                          this.$message.error('请完善被告人信息！')
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 3) {
                  if (this.form.ajstatus == '一审(行政诉讼)') {
                     if((this.form.tableData.some(
                        (item) => item.Attribute == '原告'
                      )|| this.form.tableData.some(
                        (item) => item.Attribute == '被告'
                      ))&&(this.form.tableData.some(
                        (item) => item.Attribute == '请求人'
                      )|| this.form.tableData.some(
                        (item) => item.Attribute == '权利人'
                      ))){
                        this.loading = false
                        this.dianji = false
                        return this.$message.error('原告被告与请求人权利人不能同时存在！')
                      }
                     if (
                      this.form.tableData.some(
                        (item) => item.Attribute == '原告'
                      )|| this.form.tableData.some(
                        (item) => item.Attribute == '被告'
                      )
                    ) {
                      if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '原告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被告'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被告！')
                    }
                    }else if (
                      this.form.tableData.some(
                        (item) => item.Attribute == '请求人'
                      )|| this.form.tableData.some(
                        (item) => item.Attribute == '权利人'
                      )
                    ) {
                      if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '请求人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加请求人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '权利人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加权利人！')
                    }
                    }
                    else{
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加原告或请求人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '原告') {
                          this.$message.error('请完善原告信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被告') {
                          this.$message.error('请完善被告信息！')
                          bitian = false
                          break
                        }else if (arrbt[i].Attribute == '请求人') {
                          this.$message.error('请完善请求人信息！')
                          bitian = false
                          break
                        }else if (arrbt[i].Attribute == '权利人') {
                          this.$message.error('请完善权利人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '二审(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加上诉人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被上诉人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被上诉人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '上诉人') {
                          this.$message.error('请完善上诉人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被上诉人') {
                          this.$message.error('请完善被上诉人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '申请再审(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政裁决') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请人！')
                    }
                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被申请人') {
                          this.$message.error('请完善被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政复议') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '复议申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加复议申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '复议被申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加复议被申请人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '复议申请人') {
                          this.$message.error('请完善复议申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '复议被申请人') {
                          this.$message.error('请完善复议被申请人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '执行阶段(行政诉讼)') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请执行人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请执行人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请执行人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请执行人') {
                          this.$message.error('请完善申请执行人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被申请执行人') {
                          this.$message.error('请完善被申请执行人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政处罚') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '当事人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加当事人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '行政主体'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加行政主体！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '当事人') {
                          this.$message.error('请完善当事人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '行政主体') {
                          this.$message.error('请完善行政主体信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政许可') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被许可人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被许可人！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被许可人') {
                          this.$message.error('请完善被许可人信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '行政强制') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '当事人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加当事人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '行政主体'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加行政主体！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '当事人') {
                          this.$message.error('请完善当事人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '行政主体') {
                          this.$message.error('请完善行政主体信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  } else if (this.form.ajstatus == '政府信息公开') {
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '申请人'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加申请人！')
                    }
                    if (
                      !this.form.tableData.some(
                        (item) => item.Attribute == '被申请机关'
                      )
                    ) {
                      this.loading = false
                      this.dianji = false
                      return this.$message.error('请添加被申请机关！')
                    }

                    for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '申请人') {
                          this.$message.error('请完善申请人信息！')
                          bitian = false
                          break
                        } else if (arrbt[i].Attribute == '被申请机关') {
                          this.$message.error('请完善被申请机关信息！')
                          bitian = false
                          break
                        }
                      }
                    }
                  }
                } else if (this.numType == 4) {
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '申请执行人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加申请执行人！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '被执行人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加被执行人！')
                  }
                  for (let i = 0; i < arrbt.length; i++) {
                    if (
                      arrbt[i].Name == '' ||
                      arrbt[i].Name == null ||
                      arrbt[i].IsClient === '' ||
                      arrbt[i].IsClient === null ||
                      arrbt[i].IsUnit === '' ||
                      arrbt[i].IsUnit === null||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                    ) {
                      if (arrbt[i].Attribute == '申请执行人') {
                        this.$message.error('请完善申请执行人信息！')
                        bitian = false
                        break
                      } else if (arrbt[i].Attribute == '被执行人') {
                        this.$message.error('请完善被执行人信息！')
                        bitian = false
                        break
                      }
                    }
                  }
                } else if (this.numType == 5 || this.numType == 6) {
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '申请人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加申请人！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '被申请人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加被申请人！')
                  }
                  
                  for (let i = 0; i < arrbt.length; i++) {
                    if (
                      arrbt[i].Name == '' ||
                      arrbt[i].Name == null ||
                      arrbt[i].IsClient === '' ||
                      arrbt[i].IsClient === null ||
                      arrbt[i].IsUnit === '' ||
                      arrbt[i].IsUnit === null||
                      arrbt[i].Idnumber === '' ||
                      arrbt[i].Idnumber === null
                    ) {
                      if (arrbt[i].Attribute == '申请人') {
                        this.$message.error('请完善申请人信息！')
                        bitian = false
                        break
                      } else if (arrbt[i].Attribute == '被申请人') {
                        this.$message.error('请完善被申请人信息！')
                        bitian = false
                        break
                      }
                    }
                  }
                }
                if (bitian == false) {
                  this.loading = false
                  this.dianji = false
                  return
                }
                for (let i = 0; i < arrbt.length; i++) {
                  if (
                    arrbt[i].Name == '' ||
                    arrbt[i].Name == null ||
                    arrbt[i].IsUnit === '' ||
                    arrbt[i].IsUnit === null||
                    arrbt[i].Idnumber === '' ||
                    arrbt[i].Idnumber === null
                    
                  ) {
                    if (
                      arrbt[i].Attribute == '第三人' ||
                      arrbt[i].Attribute == '原审第三人' ||
                      arrbt[i].Attribute == '原审原告' ||
                      arrbt[i].Attribute == '原审被告' ||
                      arrbt[i].Attribute == '执行异议人' ||
                      arrbt[i].Attribute == '案外人' ||
                      arrbt[i].Attribute == '利害关系人' ||
                      arrbt[i].Attribute == '有关公民' ||
                      arrbt[i].Attribute == '代理人' ||
                      arrbt[i].Attribute == '继承人' ||
                      arrbt[i].Attribute == '遗产管理人' ||
                      arrbt[i].Attribute == '被害人' ||
                      arrbt[i].Attribute == '执行异议中的利害关系人' ||
                      arrbt[i].Attribute == '行政主体' ||
                      arrbt[i].Attribute == '其他人员' ||
                      arrbt[i].Attribute == '第三方'||arrbt[i].Attribute == '债权人'||arrbt[i].Attribute == '申请人'||arrbt[i].Attribute == '被申请人'||arrbt[i].Attribute == '复议申请人'
                    ) {
                      if (
                        (arrbt[i].Name == '' || arrbt[i].Name == null) &&
                        (arrbt[i].IsClient !== true) &&
                        (arrbt[i].IsUnit === '' || arrbt[i].IsUnit === null)&&
                        (arrbt[i].Idnumber === '' || arrbt[i].Idnumber === null)
                      ) {
                       
                        this.form.tableData.splice(i, 1)
                        i--
                      } 
                      else if (
                        arrbt[i].Name != '' ||
                        arrbt[i].Name != null ||
                        arrbt[i].IsUnit !== '' ||
                        arrbt[i].IsUnit !== null||
                        arrbt[i].Idnumber !== '' ||
                        arrbt[i].Idnumber !== null
                      ) {
                        if (
                          arrbt[i].Name == '' ||
                          arrbt[i].Name == null ||
                          arrbt[i].IsUnit === '' ||
                          arrbt[i].IsUnit === null||
                          arrbt[i].Idnumber === '' ||
                          arrbt[i].Idnumber === null
                        ) {
                          bitian = false
                          // console.log("sad",arrbt[i].Attribute)
                          this.$message.error(
                            '请完善' + arrbt[i].Attribute + '信息！'
                          )
                          break
                        }
                      }
                    }
                  }
                }
                if (bitian == false) {
                  this.loading = false
                  this.dianji = false
                  return
                }

                this.form.tableData = this.form.tableData.filter(
                  (item) =>
                    item.Name != '' &&
                    item.Name != null &&
                    item.IsClient !== '' &&
                    item.IsClient !== null &&
                    item.IsUnit !== '' &&
                    item.IsUnit !== null&&
                    item.Idnumber !== '' &&
                    item.Idnumber !== null
                )
                var att = ''
                this.form.tableData.forEach((value, index, array) => {
                  if (value.IsClient) {
                    att = value.Attribute
                  }
                })
                await caseConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    // 弹出案件冲突
                    this.dialogallConflictCase = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.loading = false
                    this.dianji = false
                    this.$message.error(res.data.message)
                  }
                  
                })
               
                 await caseAdviserApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    // console.log('顾问冲突', res.data.data)
                    this.lvShiConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                    this.loading = false
                    this.dianji = false
                  }
                  
                })

                 await BanruptcykConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    this.BanruptcykConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                    this.loading = false
                    this.dianji = false
                  }
                  
                })
                if (
                  this.lvShiConflict.length > 0 ||
                  this.dialogallConflictCase.length > 0||this.BanruptcykConflict.length>0
                ) {
                 
                  this.loading = false
                  this.dianji = false
                 
                  this.allConflictCount=0
                  this.formConflict.conflictApproval=null
                  this.conflictShow=false
                  if(this.lvShiConflict.length > 0){
                     this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.isClient == 1).length
                  }
                  if(this.dialogallConflictCase.length > 0){
                    this.conflictList=this.dialogallConflictCase.filter(item => item.conId == 1)
                    this.allConflictCount  = this.allConflictCount +this.conflictList.length
                    if(this.conflictList.length==0){
                      this.conflictList.push(this.dialogallConflictCase[0])
                    }
                    if(this.dialogallConflictCase.length>this.conflictList.length&&this.dialogallConflictCase.length>1){
                      this.dialoghasMore=true
                    }
                  }
                  if(this.BanruptcykConflict.length>0){
                    this.allConflictCount = this.allConflictCount +this.BanruptcykConflict.filter(item => item.isClient == 1).length
                  }
                  // console.log(this.allConflictCount )
                  if(this.allConflictCount>0){
                    await this.GetConflictMember()
                  }else{
                    this.caseConflict = true
                 
                  }
                } else {
                  // 确认新增
                  this.ProcessType = ['case_entry', 'type_seal']
                  // this.FileList = this.FileList1.concat(this.FileList2)
                  this.addEnter()
                }
              } else if (
                this.numType == 7 ||
                this.numType == 8 ||
                this.numType == 14 ||
                this.numType == 9
              ) {
                if (this.numType == 9) {
                  if (this.form.tableData.length == 0) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请录入案件当事人!')
                  }

                  var clientBool = false
                  arrbt.forEach((v) => {
                    if (v.IsClient == true) {
                      clientBool = true
                      return
                    }
                  })
                  if (!clientBool) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请选择代理方！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '客户名称'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加客户名称！')
                  }
                  if (
                    !this.form.tableData.some(
                      (item) => item.Attribute == '对方当事人'
                    )
                  ) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('请添加对方当事人！')
                  }
                  // console.log(arrbt)
                  for (let i = 0; i < arrbt.length; i++) {
                      if (
                        arrbt[i].Name == '' ||
                        arrbt[i].Name == null ||
                        arrbt[i].IsClient === '' ||
                        arrbt[i].IsClient === null ||
                        arrbt[i].IsUnit === '' ||
                        arrbt[i].IsUnit === null ||
                        arrbt[i].Idnumber === '' ||
                        arrbt[i].Idnumber === null
                      ) {
                        if (arrbt[i].Attribute == '客户名称') {
                          this.loading = false
                          this.dianji = false
                          this.$message.error('请完善客户信息！')
                          return
                        } else if (arrbt[i].Attribute == '对方当事人') {
                          this.loading = false
                          this.dianji = false
                          this.$message.error('请完善对方当事人信息！')
                          return
                        }
                      }
                    }
                  this.form.tableData = this.form.tableData.filter(
                    (item) =>
                      item.Name != '' &&
                      item.Name != null &&
                      item.IsClient !== '' &&
                      item.IsClient !== null&&
                      item.Idnumber !== '' &&
                      item.Idnumber !== null
                  )
                  var att = ''
                  this.form.tableData.forEach((value, index, array) => {
                    if (value.IsClient) {
                      att = value.Attribute
                    }
                  })
                  await caseConflictApi({
                    listLitigant_param: this.form.tableData,
                    CaseId: null,
                    Attribute: att
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      // 弹出案件冲突
                      this.conflictList = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.loading = false
                    this.dianji = false
                  })
                  await caseAdviserApi({
                    listLitigant_param: this.form.tableData,
                    CaseId: null,
                    Attribute: att
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      this.lvShiConflict = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.loading = false
                    this.dianji = false
                  })
                await BanruptcykConflictApi({
                  listLitigant_param: this.form.tableData,
                  CaseId: null,
                  Attribute: att
                }).then((res) => {
                  if (res.data.status == 'success') {
                    this.BanruptcykConflict = res.data.data
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.$message.error(res.data.message)
                    this.loading = false
                    this.dianji = false
                  }
                  
                })
                  if (
                    this.lvShiConflict.length > 0 ||
                    this.conflictList.length > 0||this.BanruptcykConflict.length>0
                  ) {
                    this.caseConflict = true
                    this.allConflictCount=0
                    this.formConflict.conflictApproval=null
                    if(this.lvShiConflict.length > 0){
                      this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.isClient == 1).length
                    }
                    if(this.conflictList.length > 0){
                      this.allConflictCount  = this.allConflictCount +this.conflictList.filter(item => item.conId == 1).length
                    }
                      if(this.BanruptcykConflict.length > 0){
                      this.allConflictCount = this.allConflictCount +this.BanruptcykConflict.filter(item => item.isClient == 1).length
                    }
                    if(this.allConflictCount>0){
                      await this.GetConflictMember()
                      
                    }else{
                      this.caseConflict = true
                    }
                  } else {
                    // 确认新增
                    this.ProcessType = ['case_entry', 'type_seal']
                    // this.FileList = this.FileList1.concat(this.FileList2)
                    this.addEnter()
                  }
                  // if (this.form.level.length != 1) {
                  //   this.loading = false
                  //   return this.$message.error('风控委必须选择一人！')
                  // } else {
                  //   // 确认新增
                  //   this.ProcessType = ['case_entry', 'type_seal']
                  //   // this.FileList = this.FileList1.concat(this.FileList2)
                  //   this.addEnter()
                  // }
                } else {
                  if (this.form.level.length != 2) {
                    this.loading = false
                    this.dianji = false
                    return this.$message.error('风控委必须选择两人！')
                  } else {
                    // 确认新增
                    this.ProcessType = ['case_entry', 'type_seal']
                    // this.FileList = this.FileList1.concat(this.FileList2)
                    this.addEnter()
                  }
                }
              }  //专项服务合同
               else if(this.numType==11){
                  await caseConflictApi({
                    listLitigant_param:  this.form.bcz.tableData,
                    CaseId: null,
                    Attribute: "客户名称"
                  }).then((res) => {
                    if (res.data.status == 'success') {
                      // 弹出案件冲突
                      this.conflictList = res.data.data
                    } else if (
                      res.data.status == '401' ||
                      res.data.status == '402' ||
                      res.data.status == '403'
                    ) {
                      this.$message.error(res.data.message)
                      window.sessionStorage.removeItem('token')
                      window.sessionStorage.removeItem('hasRoles')
                      this.$router.push('/login')
                      return
                    } else {
                      this.$message.error(res.data.message)
                    }
                    this.loading = false
                    this.dianji = false
                  })
                  // await caseAdviserApi({
                  //   listLitigant_param: this.form.tableData,
                  //   CaseId: null,
                  //   Attribute: att
                  // }).then((res) => {
                  //   if (res.data.status == 'success') {
                  //     this.lvShiConflict = res.data.data
                  //   } else if (
                  //     res.data.status == '401' ||
                  //     res.data.status == '402' ||
                  //     res.data.status == '403'
                  //   ) {
                  //     this.$message.error(res.data.message)
                  //     window.sessionStorage.removeItem('token')
                  //     window.sessionStorage.removeItem('hasRoles')
                  //     this.$router.push('/login')
                  //     return
                  //   } else {
                  //     this.$message.error(res.data.message)
                  //   }
                  //   this.loading = false
                  //   this.dianji = false
                  // })

                  if (
                    // this.lvShiConflict.length > 0 ||
                    this.conflictList.length > 0
                  ) {
                    this.caseConflict = true
                    this.allConflictCount=0
                    this.formConflict.conflictApproval=null
                    // if(this.lvShiConflict.length > 0){
                    //   this.allConflictCount = this.allConflictCount +this.lvShiConflict.filter(item => item.conId == 1).length
                    // }
                    if(this.conflictList.length > 0){
                      this.allConflictCount  = this.allConflictCount +this.conflictList.filter(item => item.conId == 1).length
                    }
                    if(this.allConflictCount>0){
                      await this.GetConflictMember()
                      
                    }else{
                      this.caseConflict = true
                    }
                  } else {
                    // 确认新增
                    this.ProcessType = ['case_entry', 'type_seal']
                    // this.FileList = this.FileList1.concat(this.FileList2)
                    this.addEnter()
                  }
                }
              else {
                // 确认新增
                this.ProcessType = ['case_entry', 'type_seal']
                // this.FileList = this.FileList1.concat(this.FileList2)
                this.addEnter()
              }
            } else {
              this.$nextTick(() => {
                const errorField = this.$el.querySelector(
                  '.el-form-item.is-error'
                )
                if (errorField) {
                  errorField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  })
                }
              })
              this.loading = false
              this.dianji = false
              this.$message.error('请检查用章信息填写错误!')
            }
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.loading = false
          this.dianji = false
          this.$message.error('请检查案件信息填写错误!')
        }
      })
    },

    // 部门主管改变
    bmzgChange() {
      this.$forceUpdate()
    },

    // 全新录入监控
    inputDraft(newVal) {
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      // console.log('全新录入监控', cgForm)
      // if (cgForm.length > 1) {
      cgForm = cgForm.slice(0, -1)
      cgForm.push(newVal)
      localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))
      // } else {
      //   localStorage.setItem('draftForm' + this.numType, JSON.stringify(newVal))
      // }
    },

    // 全新录入
    async inputDraftNew(b) {
      // console.log('全新录入', this.form)
      // console.log('caoGao', this.caoGao)

      this.centerDialogVisible = false
    },

    // 保存草稿
    saveCaoGao() {
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))

      var you = false
      // 是否是首次录入草稿
      if (cgForm != null) {
        cgForm.forEach((value, index, arr) => {
          if (value.uuid == this.form.uuid) {
            you = true
            return (arr[index] = this.form)
          }
        })
        if (!you) {
          // 多次录入新的草稿
          this.form.draftFormType = this.numType
          this.form.draftFormId = window.sessionStorage.getItem('userId')
          this.form.uuid = this.guid()
          cgForm.push(this.form)
          localStorage.setItem(
            'draftForm' + this.numType,
            JSON.stringify(cgForm)
          )
        } else {
          // 更新原有草稿
          localStorage.setItem(
            'draftForm' + this.numType,
            JSON.stringify(cgForm)
          )
        }
      } else {
        // 首次录入草稿
        this.form.draftFormType = this.numType
        this.form.draftFormId = window.sessionStorage.getItem('userId')
        this.form.uuid = this.guid()
        this.caoGao.push(this.form)
        localStorage.setItem(
          'draftForm' + this.numType,
          JSON.stringify(this.caoGao)
        )
      }
      this.$message.success('保存成功！')
    },

    // // 修改草稿
    // updateCaoGao() {
    //   // 取出local数据并修改
    //   var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
    //   cgForm.forEach((value, index, arr) => {
    //     if (value.uuid == this.cgid) {
    //       return (arr[index] = this.form)
    //     }
    //   })

    //   // 再次写入local
    //   localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))

    //   this.$message.success('修改成功！')
    // },

    // 原有草稿录入监控
    inputDraftOld(nv) {
      // 取出local数据并修改
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      cgForm.forEach((value, index, arr) => {
        if (value.uuid == this.cgid) {
          return (arr[index] = nv)
        }
      })

      // 再次写入local
      // console.log('再次写入local', cgForm)
      localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))
    },

    // 判断当前案件是否存在草稿
    async caoGaoSelect() {
      this.loading = false
      this.dianji = false
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      if (cgForm != null) {
        if (cgForm.length > 0) {
          cgForm.forEach((value, index, arr) => {
            if (value.draftFormId == window.sessionStorage.getItem('userId')) {
              this.caoGao.push(value)
              this.my = true
            }
          })
          if (this.my) {
            this.centerDialogVisible = true
          } else {
            await this.inputDraftNew(true)
          }
        }
      } else {
        await this.inputDraftNew(true)
      }
    },

    // 草稿录入
    caoGaoInput() {
      this.cgDialogVisible = true
    },

    // 删除草稿
    scCG(scid) {
      // console.log(scid)
      // console.log(this.caoGao)
      if (scid == null) {
        return this.$message.error('请选择要删除的草稿！')
      }
      for (var a = 0; a < scid.length; a++) {
        this.caoGao.forEach((value, index, array) => {
          if (value.uuid == scid[a]) {
            array.splice(index, 1)
          }
        })
      }

      if (this.caoGao.length == 0) {
        localStorage.removeItem('draftForm' + this.numType)
      } else {
        // localStorage.setItem(
        //   'draftForm' + this.numType,
        //   JSON.stringify(this.caoGao)
        // )
      }
      this.$message.success('删除成功')
      this.scDialogVisible = false
      this.centerDialogVisible = false
      this.inputDraftNew(true)
    },

    // 取出选择的草稿
    cgInput(cgid) {
      if (cgid == null || cgid == '') {
        return this.$message.error('请选择草稿')
      }
      var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
      cgForm.forEach((v, i, arr) => {
        if (v.uuid == cgid) {
          return (this.form = v)
        }
      })
      this.form.sealForm.sealFile = []
      this.SF_Chargestatus(this.form.chargingMethod)
      this.LeadLawyerChange(this.form.leadLawyer, 'caogao')
      this.bmzgChange()
      this.repeatType()
      this.caoGao1 = true
      this.cgDialogVisible = false
      this.centerDialogVisible = false
    },

    // 删除草稿
    deleteCaoGao() {
      this.scDialogVisible = true
    },

    // 确认新增
    addEnter() {
      this.loading = true
      this.dianji = true
      if (this.FileList1.length == 0) {
        this.loading = false
        this.dianji = false
        return this.$message.error('至少要上传一个合同附件！2752')
      }
      if (this.FileList.length == 0) {
        this.loading = false
        this.dianji = false
        return this.$message.error('请选择合同用章附件！')
      }

      // 筛选选中的打印材料
      var newCities = []
      var st = []
      // console.log(this.form.sealForm.checkedCities,this.form.sealForm.cities)
      this.form.sealForm.checkedCities.forEach((cv) => {
        this.form.sealForm.cities.forEach((cvc) => {
          if (cv == cvc.name) {
            newCities.push(cvc)
            if (cvc.stype != null && cvc.stype != '') {
              st.push(cvc.stype)
            }
          }
        })
      })
      var khmc=null
      var idnumber = null
      // if(this.numType==11){
      //   khmc = this.form.bcz.procureunit
      //   idnumber = this.form.bcz.procureunit
      // }
      var nst = st
        .flat()
        .filter(Boolean)
        .filter((value, index, self) => self.indexOf(value) === index && value)
        .join(',')

      var tableData=this.form.tableData == [] ? null : this.form.tableData
       if(this.numType==11){
        tableData=this.form.bcz.tableData
       }
       console.log(this.form.bcz.tableData)
      caseInputApi({
        // 案件信息
        CaseStatus: this.form.casestatus,
        AcceptCode: this.form.acceptcode,
        Aid: this.form.assist == null || '' ? false : this.form.assist,
        Title: this.form.name,
        Code: this.form.code,
        TypeId: this.form.caseType,
        Name: this.form.ajstatus,
        EntrustmentTime: this.form.approvaldate,
        Source: this.form.source,
        AcceptUnit: this.form.acceptUnit,
        Cause: this.form.cause,
        LeadLawyer: this.form.leadLawyer,
        Remark: this.form.remark,
        LinkId: this.form.linkId == '' ? null : this.form.linkId,
        CoCounsel: this.form.coCounsel == null || '' ? [] : this.form.coCounsel,
        ApproveId: this.form.level == [] ? null : this.form.level,
        MemberId: this.form.criminalrisk==''?null:this.form.criminalrisk,
        CaseLeaders: this.form.caseLeaders,
        SealLeaders: this.form.sealForm.sealLeaders,
        //收费信息
        ChargingMethod: this.form.chargingMethod,
        AmountOfSubject:
          this.form.amountOfSubject == null || ''
            ? 0
            : this.form.amountOfSubject,
        SubjectMatter: this.form.subjectMatter,
        Fixed: this.form.fixed == null || this.form.fixed=='' ? 0 : this.form.fixed,
        RiskFixed: this.form.riskFixed == null || this.form.riskFixed=='' ? 0 : this.form.riskFixed,
        RiskRatio: this.form.riskRatio == null || this.form.riskRatio=='' ? 0 : this.form.riskRatio,
        BCB_Remark: this.form.sf_remark,
        Introduction: this.form.introduction,
        FixedTimes: this.form.bcbdTable.length,
        //收费信息明细
        // listBillingDetail_param:
        //   this.form.bcbdTable == [] ? null : this.form.bcbdTable,
        listBillingDetail_param: null,
        //用章申请
        // SealType: this.form.sealForm.seal,
        SealType: nst,
        newSealTypes: JSON.stringify(newCities),
        Reason: this.form.sealForm.reason,
        ApplicantId: this.form.sealForm.applicant,
        BS_ApproveId: this.form.sealForm.leadLawyer2, //二次
        // 案件当事人
        listLitigant_param:
          tableData,
        //所有附件
        biddingSchemes: this.form.biddingSchemes, //合同上传
        chujuFiles: this.form.chujuFiles, // 拟出具文件
        ordinaryFiles: this.form.ordinaryFiles, //普通附件
        freeFiles: this.form.freeFiles, // 免费凭证
        File: this.form.sealForm.sealFile, //用章申请附件
        //其他东西
        ExtInfo: JSON.stringify(this.form.bcz),
        LP_ProcessType: this.ProcessType,
        ConflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval,
        khmc:khmc,
        idnumber:idnumber,
      })
        .then((res) => {
          if (res.data.status == '0') {
            this.loading = false
            this.dianji = false
            var cgForm = JSON.parse(
              localStorage.getItem('draftForm' + this.numType)
            )
           
            if (cgForm != null) {
              if (cgForm.length == 1) {
                localStorage.removeItem('draftForm' + this.numType)
              } else {
                cgForm.forEach((value, index, arr) => {
                  if (value.uuid == this.cgid) {
                    return arr.splice(index, 1)
                  }
                })
                localStorage.setItem(
                  'draftForm' + this.numType,
                  JSON.stringify(cgForm)
                )
              }
            }

            // localStorage.removeItem('draftForm' + this.numType)
            // localStorage.removeItem('draftFormType' + this.numType)
            // localStorage.removeItem('draftFormId' + this.numType)
            this.$message.success('录入成功！')
            setTimeout(() => {
              this.$router.back()
            }, 100)
          } else if(res.data.status=='Filefail'){
            this.$message.error(res.data.message)
            this.loading = false
            this.dianji = false
            this.caseConflict = false
            this.FileList1 = []
            this.FileList4 = []
            this.FileList = []
            this.FileList2 = []
            this.FileList3 = []
          }else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.loading = false
            this.dianji = false
            this.$message.error('录入失败！')
            setTimeout(() => {
              // this.$router.go(-1)
              this.$router.back()
            }, 100)
          }
          
        })
        .catch((err) => {
          // console.log(err)
          this.loading = false
          this.dianji = false
          this.$message.error('录入失败！后台错误！')
          setTimeout(() => {
            this.$router.back()
          }, 100)
        })
      // this.loading = false
      // this.dianji = false
    },

    // 继续录入
    conflict(formref) {
      this.loading = true
      this.dianji = true
      this.$refs[formref].validate((valid) => {
        if (valid) {
          // 确认新增
          this.ProcessType = ['case_entry', 'type_seal']
          this.caseConflict = false // 冲突
          this.addEnter()
        }else{
          this.dianji = false
          this.loading=false
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        }
      }
      )
      
    },

    // 我再想想
    edit() {
      this.conflictList = []
      this.lvShiConflict = []
      this.caseConflict = false // 冲 突
      this.dialogshowAllCase=false
      this.dialoghasMore=false
      this.formConflict.conflictApproval=null
    },

    // 获取所有关联案件Link
    async GetCaseLink(casetitle) {
      this.caseLinkloading = true
      await getCaseLinkApi({
        CaseTypeId: this.$route.query.status,
        CaseTitle: casetitle
      })
        .then((res) => {
          if (res.data.status == '0') {
            this.Caselevel = res.data.data
            this.caseLinkloading = false
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.caseLinkloading = false
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.caseLinkloading = false
            this.$message.error('关联案件Link获取失败!')
          }
        })
        .catch(() => {
          this.caseLinkloading = false
          this.$message.error('错误!')
        })
    },

    // 关联是否可改
    Sup() {
      if (typeof this.$route.query.linkid != 'undefined') {
        this.form.linkId = this.$route.query.linkid
      }
      if (this.$route.query.sup == 'false') {
        this.sup = false
      } else if (this.$route.query.sup == 'true') {
        this.sup = true
      }
    },

    // 代理律师/申请人/代理律师
    async GetLawyer() {
      await caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status == 6)
          // this.Lawyer = res.data.data
          this.form.leadLawyer = res.data.data[0].uid.split()
          this.form.sealForm.applicant = res.data.data[0].uid
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 代理律师 改变
    async LeadLawyerChange(lvshi, cg) {
      await this.GetLevel(lvshi[0], cg)
      await this.GetFKW(lvshi[0], cg)
      await this.GetCriminal(lvshi[0], cg)
      await this.GetDepartmentLeaders(lvshi[0], cg)
    },

    // 获取案件审核部门主管
    async GetDepartmentLeaders(lvshi, cg) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      if (cg == null) {
        this.form.caseLeaders = null
      }

      await caseDepartmentLeadersApi({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 案件二次审批人/用章二次审批人
    async GetLevel(lvshi, cg) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      if (cg == null) {
        this.form.level = null
      }

      await caseLawyerApi({
        Id: lvshi,
        apporver: 'case_' + this.$route.query.status,
        risk_controler: null,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 风控委
    async GetFKW(lvshi, cg) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      if (cg == null) {
        this.form.level = null
      }

      await caseLawyerApi({
        Id: lvshi,
        apporver: null,
        risk_controler: true,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.FKW = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 刑事风险控制人
    async GetCriminal(lvshi, cg) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      // if (cg == null) {
      //   this.form.criminalrisk = null
      // }
      await caseLawyerApi({
        Id: lvshi,
        apporver: null,
        risk_controler: null,
        criminal_risk_controler: true
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Criminal = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 用章类型改变,查找审批人
    async GetSealLevel() {
      // console.log(this.form.sealForm.cities)
      if (
        this.form.sealForm.applicant == '' ||
        this.form.sealForm.applicant == null
      ) {
        return
      }
      this.form.sealForm.leadLawyer2 = null
      var newSeal = []
      this.form.sealForm.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [
        ...new Map(newSeal.map((item) => [item, item])).values()
      ].join(',')
      await caseLawyerApi({
        Id: this.form.sealForm.applicant,
        apporver: uniqueArr,
        risk_controler: null,
        criminal_risk_controler: null
      }).then((res) => {
        if (res.data.status == 'success') {
          this.SealLevel = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    // 用章申请人改变
    async SealLawyer() {
      if (
        this.form.sealForm.applicant == '' ||
        this.form.sealForm.applicant == null
      ) {
        return
      }
      this.form.sealForm.seal = null
      this.form.sealForm.sealLeaders = null
      this.form.sealForm.leadLawyer2 = null
      await caseDepartmentLeadersApi({
        Id: this.form.sealForm.applicant
      }).then((res) => {
        if (res.data.status == '0') {
          this.SealLeaders = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    arrToString(arr) {
      return arr.join(' , ')
    },
    closChong() {
      this.isChong = false
    },

    // 案件冲突查看
    conflictClick(row) {
      // this.$store.commit('setmenustatus', 1)
      // this.$router.push({
      //   path: '/home/case/caseinfo',
      //   query: {
      //     guid: row.id,
      //     status: row.typeId,
      //     caseType: row.typeId.substring(21, 23)
      //   }
      // })
      this.chongCaseType = row.typeId.substring(21, 23)
      allCaseApi({
        Id: row.id,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // console.log('res.data.data[0]', res.data.data[0])
          // 案件信息
          this.CTform = res.data.data[0];
          this.CTform.tableData = res.data.data[0].tableData
          //其他东西
          this.CTform.bcz = Object.assign({}, this.CTform.bcz, JSON.parse(res.data.data[0].bcz));
          this.CTform.bcz.tableData=[]
           if(this.chongCaseType==11&&this.CTform.tableData){
            this.$set(this.CTform, 'bcz', {
              tableData: (this.CTform.tableData || []).map(item => ({
                id: item.id,
                name: item.name ,
                idnumber: item.idnumber ,
                isUnit: item.isUnit,
                isClient: item.isClient,
                attribute: item.attribute || "客户名称",
                count: item.sort,
                order: item.order,
              }))
            });
           }
          // this.CTform = res.data.data[0]
          // this.CTform.tableData = res.data.data[0].tableData
          // //其他东西
          // this.CTform.bcz = JSON.parse(res.data.data[0].bcz)
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split('.')[0]
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
          }
          this.isChong = true
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 时间格式转换
    formatTime(row) {
      if(row==''||row==null){
        return ''
      }
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year + '-' + month + '-' + day
        // +
        // ' ' +
        // hours +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
    },

    // 案件当事人背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.isClient||row.IsClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },

    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    // guid生成
    guid() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },

    // reasonClick(t) {
    //   this.form.sealForm.reason = t
    // }
    async defaultAjstatus() {
      var ct = this.$route.query.status
      this.Chargestatus=this.Chargestatus1
      if (ct == '00000000-0000-0000-0001-000000000000') {
        this.form.ajstatus = '一审'
      } else if (ct == '00000000-0001-0001-0002-000000000000') {
        this.form.ajstatus = '侦查'
        this.Chargestatus=this.Chargestatus2
      } else if (ct == '00000000-0002-0002-0003-000000000000') {
        this.form.ajstatus = '一审(行政诉讼)'
      } else if (ct == '00000000-0003-0003-0004-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0004-0004-0005-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0005-0005-0006-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0006-0006-0007-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0007-0007-0008-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0013-0013-0014-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0008-0008-0009-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0009-0009-0010-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0010-0010-0011-000000000000') {
        this.form.ajstatus = '受理'
      } else if (ct == '00000000-0014-0014-0015-000000000000') {
        this.form.ajstatus = '受理'
      }
      this.form.sealForm.cities = [
        {
          name: '授权委托书(单位)', // 模板名
          type: 1, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '授权委托书(个人)', // 模板名
          type: 1, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '执行授权委托书(单位)', // 模板名
          type: 1, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '执行授权委托书(个人)', // 模板名
          type: 1, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '法律意见书审批单', // 模板名
          type: 2, // 类型(1:导出，2:打印)
          stype: ['law_seal'] // 用章类型
        },
        {
          name: '单独出具律师函审批单', // 模板名
          type: 2, // 类型(1:导出，2:打印)
          stype: ['legal_letter_seal'] // 用章类型
        },
        {
          name: '案件审批单', // 模板名
          type: 2, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '律师出庭函', // 模板名
          type: 2, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        },
        {
          name: '行政复议出庭函', // 模板名
          type: 2, // 类型(1:导出，2:打印)
          stype: ['official_seal'] // 用章类型
        }
      ]
      if (this.form.sealForm.checkedCities.length > 0) {
        this.form.sealForm.checkedCities = []
      }
      this.form.sealForm.cities.forEach((value) => {
        this.form.sealForm.checkedCities.push(value.name)
      })
    },
    tableRowClass({ row, rowIndex }){
      // console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }
  },
  async created() {
    this.GetLit()
    await this.defaultAjstatus()
    await this.GetLawyer()
    await this.GetCaseLink()
    this.Sup()
    if (this.form.leadLawyer.length > 0) {
      await this.LeadLawyerChange(this.form.leadLawyer)
    }
    if (
      this.form.sealForm.applicant != null ||
      this.form.sealForm.applicant != ''
    ) {
      await this.SealLawyer()
    }
    await this.inputType(this.form.ajstatus, null)
    await this.caoGaoSelect()
    await this.GetSealLevel()
    
  },

  watch: {
    caoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿old', newVal)
              // this.inputDraftOld(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    },

    newcaoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿new', newVal)
              this.inputDraft(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    },

    // 'form.tableData': {
    //   handler(newValue, oldValue) {
    //     if (newValue.length > 0 && oldValue.length == 0) {
    //       this.getLitigants()
    //     }
    //   },
    //   deep: true
    // }
  }
}
</script>
  
<style lang="less" scoped>
#caseinput {
  width: 100%;
  height: 100%;
}
//主体
.text {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}
::v-deep .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}

::v-deep .el-tag.el-tag--info {
  color: #606266 !important;
}

.title {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.main {
  width: 99%;
  margin: auto;
  padding-bottom: 30px;
}

.main_card {
  width: 100%;
  border-radius: 12px;
  padding-bottom: 20px;
}

.case {
  width: 100%;
  margin: auto;
}

.top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  padding-left: 58px;
  margin-bottom: 32px;
}

.icon {
  width: 4px;
  height: 18px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}

.contain {
  width: 100%;
  .el-descriptions {
    padding-left: 70px;
  }
}

/deep/ .el-form-item__label {
  font-size: 17px;
  font-weight: 400;
}

.select {
  width: 100%;
}

.divider {
  width: calc(100% - 50px);
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 32px;
  margin-top: 10px;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

.date_box {
  .el-icon-date {
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 9;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}
.fj_text {
  border: 1px solid rgba(48, 119, 230, 1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(48, 119, 230, 1);
}
.el-upload__tip {
  font-size: 14px;
  font-weight: 400;
  color: rgba(182, 182, 182, 1);
  margin-left: 10px;
}

//按钮
.allbtn {
  width: 100%;
  text-align: center;
  position: fixed;
  top: 98%; /* 距顶部居中显示 */
  left: 50%; /* 距左侧居中显示 */
  transform: translate(-50%, -50%); /* 水平、垂直居中 */
  z-index: 999;
  background-color: #f5f5f5;
}
.history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

// .myupload  .imgicon-video {
// 	  display: inline-block;
// 	  width: 20px;
// 	  margin-bottom: -3px;
// 	  height: 20px;
// 	  background-size: 100% 100%;
// 	  margin-right: 10px;
// 	  background-image: url("../../../assets/images/fileicon/mp4.png");
// 	}
// 	.myupload  .imgicon-img {
// 	  display: inline-block;
// 	  width: 20px;
// 	  margin-bottom: -3px;
// 	  height: 20px;
// 	  background-size: 100% 100%;
// 	  margin-right: 10px;
// 	  background-image: url("../../../assets/images/fileicon/jpeg.png");
// 	}
// 	.myupload .imgicon-pdf {
// 	  display: inline-block;
// 	  width: 20px;
// 	  margin-bottom: -3px;
// 	  height: 20px;
// 	  background-size: 100% 100%;
// 	  margin-right: 10px;
// 	  background-image: url("../../../assets/images/fileicon/pdf.png") !important;
// 	}
.myupload /deep/ .imgicon-docx {
  display: inline-block;
  width: 20px;
  margin-bottom: -3px;
  height: 20px;
  background-size: 100% 100%;
  margin-right: 10px;
  background-image: url('../../assets/file/word.svg') !important;
}

.addrow {
  margin: 0px 0px 10px 60.5%;
  display: flex;
  ::v-deep .el-input__inner {
    width: 150px !important;
    margin-right: 10px !important;
  }
  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

.copy {
  font-size: 20px;
}
.del_btn {
  font-size: 20px;
}

//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}
.party {
  margin-bottom: 55px;
  width: 100%;
  margin: auto;
  margin-left: 5%;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }
  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  // ::v-deep .el-input__inner {
  //   border: none;
  // }
}

// 附件回显
#caseinput .upload_file {
  width: 360px;
}

#caseinput .file_show {
  width: 360px;
}

#caseinput .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#caseinput img {
  width: 100%;
  height: 100%;
}

#caseinput .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}
#caseinput .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#caseinput .word {
  line-height: 24px;
  cursor: default;
}
#caseinput /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#caseinput .look {
  color: #fe964a;
}

#caseinput .down {
  color: #2bc887;
  margin-left: 10px;
}

#caseinput .del {
  color: hsl(356, 93%, 50%);
  margin-left: 10px;
}

//进度条
#caseinput .uploadprocess {
  width: 360px;
}

#caseinput .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#caseinput .jdtext {
  width: 360px;
  display: flex;
}

#caseinput .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}

.conflic_btn {
  margin-top: 5%;
}

.litigant-container {
  // text-align: left;
}

// .custom-popper {
//   width: 200px;
// }

.yz_input {
  ::v-deep .el-input__inner {
    width: 300px !important;
  }
}

::v-deep .el-table--border th.el-table__cell,
::v-deep .el-table td.el-table__cell {
  border-bottom: none !important;
}

::v-deep .el-table--border .el-table__cell {
  border-right: none !important;
}

::v-deep .el-table td.el-table_cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}

.el-table:before {
  height: 0px;
}
::v-deep .el-form-item {
  margin-bottom: 16px !important;
}
.input_autocomplete {
  width: 100% !important;
}
/deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>
  

<style lang="less">
.custom-popper {
  width: 1000px;
}
</style>